var mitre = [
  {
    tacticid: 'TA0043',
    zhcn: '侦察',
    attack_list: [
      {
        attackid: 'T1594',
        zhcn: '搜索受害者拥有的网站',
        id: 280,
        children: []
      },
      {
        attackid: 'T1593',
        zhcn: '搜索开放网站/域名',
        id: 279,
        children: [
          {
            attackid: 'T1593.001',
            zhcn: '搜索开放网站/域名：社交媒体',
            id: 349
          },
          {
            attackid: 'T1593.002',
            zhcn: '搜索开放网站/域名：搜索引擎',
            id: 350
          },
          {
            attackid: 'T1593.003',
            zhcn: '搜索开放网站/域名：代码库',
            id: 351
          }
        ]
      },
      {
        attackid: 'T1596',
        zhcn: '搜索开放技术数据库',
        id: 278,
        children: [
          {
            attackid: 'T1596.001',
            zhcn: '搜索开放技术数据库：域名系统/被动域名系统',
            id: 344
          },
          {
            attackid: 'T1596.002',
            zhcn: '搜索开放技术数据库：WHOIS',
            id: 345
          },
          {
            attackid: 'T1596.003',
            zhcn: '搜索开放技术数据库：数字证书',
            id: 346
          },
          {
            attackid: 'T1596.004',
            zhcn: '搜索开放技术数据库：内容分发网络',
            id: 347
          },
          {
            attackid: 'T1596.005',
            zhcn: '搜索开放技术数据库：扫描数据库',
            id: 348
          }
        ]
      },
      {
        attackid: 'T1597',
        zhcn: '搜索封闭来源',
        id: 277,
        children: [
          {
            attackid: 'T1597.001',
            zhcn: '搜索封闭来源：威胁情报供应商',
            id: 342
          },
          {
            attackid: 'T1597.002',
            zhcn: '搜索封闭来源：购买技术数据',
            id: 343
          }
        ]
      },
      {
        attackid: 'T1598',
        zhcn: '信息钓鱼',
        id: 276,
        children: [
          {
            attackid: 'T1598.001',
            zhcn: '信息钓鱼：鱼叉式网络钓鱼服务',
            id: 338
          },
          {
            attackid: 'T1598.002',
            zhcn: '信息钓鱼：鱼叉式网络钓鱼附件',
            id: 339
          },
          {
            attackid: 'T1598.003',
            zhcn: '信息钓鱼：鱼叉式网络钓鱼链接',
            id: 340
          },
          {
            attackid: 'T1598.004',
            zhcn: '信息钓鱼：鱼叉式钓鱼语音',
            id: 341
          }
        ]
      },
      {
        attackid: 'T1591',
        zhcn: '收集受害者组织信息',
        id: 275,
        children: [
          {
            attackid: 'T1591.001',
            zhcn: '收集受害者组织信息：确定物理位置',
            id: 334
          },
          {
            attackid: 'T1591.002',
            zhcn: '收集受害者组织信息：业务关系',
            id: 335
          },
          {
            attackid: 'T1591.003',
            zhcn: '收集受害者组织信息：确定业务节奏',
            id: 336
          },
          {
            attackid: 'T1591.004',
            zhcn: '收集受害者组织信息：确定角色',
            id: 337
          }
        ]
      },
      {
        attackid: 'T1590',
        zhcn: '收集受害者网络信息',
        id: 274,
        children: [
          {
            attackid: 'T1590.001',
            zhcn: '收集受害者网络信息：域属性',
            id: 328
          },
          {
            attackid: 'T1590.002',
            zhcn: '收集受害者网络信息：DNS',
            id: 329
          },
          {
            attackid: 'T1590.003',
            zhcn: '收集受害者网络信息：网络信任依赖关系',
            id: 330
          },
          {
            attackid: 'T1590.004',
            zhcn: '收集受害者网络信息：网络拓扑',
            id: 331
          },
          {
            attackid: 'T1590.005',
            zhcn: '收集受害者网络信息：IP 地址',
            id: 332
          },
          {
            attackid: 'T1590.006',
            zhcn: '收集受害者网络信息：网络安全设备',
            id: 333
          }
        ]
      },
      {
        attackid: 'T1589',
        zhcn: '收集受害者身份信息',
        id: 273,
        children: [
          {
            attackid: 'T1589.001',
            zhcn: '收集受害者身份信息：凭证',
            id: 325
          },
          {
            attackid: 'T1589.002',
            zhcn: '收集受害者身份信息：电子邮件地址',
            id: 326
          },
          {
            attackid: 'T1589.003',
            zhcn: '收集受害者身份信息：员工姓名',
            id: 327
          }
        ]
      },
      {
        attackid: 'T1592',
        zhcn: '收集受害者主机信息',
        id: 272,
        children: [
          {
            attackid: 'T1592.001',
            zhcn: '收集受害者主机信息：硬件',
            id: 321
          },
          {
            attackid: 'T1592.002',
            zhcn: '收集受害者主机信息：软件',
            id: 322
          },
          {
            attackid: 'T1592.003',
            zhcn: '收集受害者主机信息：固件',
            id: 323
          },
          {
            attackid: 'T1592.004',
            zhcn: '收集受害者主机信息：客户端配置',
            id: 324
          }
        ]
      },
      {
        attackid: 'T1595',
        zhcn: '主动扫描',
        id: 271,
        children: [
          {
            attackid: 'T1595.001',
            zhcn: '主动扫描：扫描 IP 块',
            id: 318
          },
          {
            attackid: 'T1595.002',
            zhcn: '主动扫描：漏洞扫描',
            id: 319
          },
          {
            attackid: 'T1595.003',
            zhcn: '主动扫描：字典扫描',
            id: 320
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0042',
    zhcn: '资源开发',
    attack_list: [
      {
        attackid: 'T1608',
        zhcn: '部署能力',
        id: 288,
        children: [
          {
            attackid: 'T1608.001',
            zhcn: '部署能力：上传恶意软件',
            id: 385
          },
          {
            attackid: 'T1608.002',
            zhcn: '部署能力：上传工具',
            id: 386
          },
          {
            attackid: 'T1608.003',
            zhcn: '部署能力：安装数字证书',
            id: 387
          },
          {
            attackid: 'T1608.004',
            zhcn: '部署能力：路过式目标',
            id: 388
          },
          {
            attackid: 'T1608.005',
            zhcn: '部署能力：链接目标',
            id: 389
          },
          {
            attackid: 'T1608.006',
            zhcn: '部署能力：搜索引擎优化破坏',
            id: 390
          }
        ]
      },
      {
        attackid: 'T1588',
        zhcn: '获取能力',
        id: 287,
        children: [
          {
            attackid: 'T1588.001',
            zhcn: '获取能力：恶意软件',
            id: 378
          },
          {
            attackid: 'T1588.002',
            zhcn: '获取能力：工具',
            id: 379
          },
          {
            attackid: 'T1588.003',
            zhcn: '获取能力：代码签名证书',
            id: 380
          },
          {
            attackid: 'T1588.004',
            zhcn: '获取能力：数字证书',
            id: 381
          },
          {
            attackid: 'T1588.005',
            zhcn: '获取能力：漏洞利用',
            id: 382
          },
          {
            attackid: 'T1588.006',
            zhcn: '获取能力：漏洞',
            id: 383
          },
          {
            attackid: 'T1588.007',
            zhcn: '获取能力：人工智能',
            id: 384
          }
        ]
      },
      {
        attackid: 'T1585',
        zhcn: '建立账户',
        id: 286,
        children: [
          {
            attackid: 'T1585.001',
            zhcn: '建立账户：社交媒体账户',
            id: 375
          },
          {
            attackid: 'T1585.002',
            zhcn: '建立账户：电子邮件账户',
            id: 376
          },
          {
            attackid: 'T1585.003',
            zhcn: '建立账户：云账户',
            id: 377
          }
        ]
      },
      {
        attackid: 'T1587',
        zhcn: '开发能力',
        id: 285,
        children: [
          {
            attackid: 'T1587.001',
            zhcn: '开发能力：恶意软件',
            id: 371
          },
          {
            attackid: 'T1587.002',
            zhcn: '开发能力：代码签名证书',
            id: 372
          },
          {
            attackid: 'T1587.003',
            zhcn: '开发能力：数字证书',
            id: 373
          },
          {
            attackid: 'T1587.004',
            zhcn: '开发能力：漏洞利用',
            id: 374
          }
        ]
      },
      {
        attackid: 'T1584',
        zhcn: '入侵基础设施',
        id: 284,
        children: [
          {
            attackid: 'T1584.001',
            zhcn: '入侵基础设施：域名',
            id: 363
          },
          {
            attackid: 'T1584.002',
            zhcn: '入侵基础设施：DNS 服务器',
            id: 364
          },
          {
            attackid: 'T1584.003',
            zhcn: '入侵基础设施：虚拟专用服务器',
            id: 365
          },
          {
            attackid: 'T1584.004',
            zhcn: '入侵基础设施：服务器',
            id: 366
          },
          {
            attackid: 'T1584.005',
            zhcn: '入侵基础设施：僵尸网络',
            id: 367
          },
          {
            attackid: 'T1584.006',
            zhcn: '入侵基础设施：网络服务',
            id: 368
          },
          {
            attackid: 'T1584.007',
            zhcn: '入侵基础设施：无服务器',
            id: 369
          },
          {
            attackid: 'T1584.008',
            zhcn: '入侵基础设施：网络设备',
            id: 370
          }
        ]
      },
      {
        attackid: 'T1586',
        zhcn: '入侵账户',
        id: 283,
        children: [
          {
            attackid: 'T1586.001',
            zhcn: '入侵账户：社交媒体账户',
            id: 360
          },
          {
            attackid: 'T1586.002',
            zhcn: '入侵账户：电子邮件账户',
            id: 361
          },
          {
            attackid: 'T1586.003',
            zhcn: '入侵账户：云账户',
            id: 362
          }
        ]
      },
      {
        attackid: 'T1583',
        zhcn: '获取基础设施',
        id: 282,
        children: [
          {
            attackid: 'T1583.001',
            zhcn: '获取基础设施：域名',
            id: 352
          },
          {
            attackid: 'T1583.002',
            zhcn: '获取基础设施：DNS 服务器',
            id: 353
          },
          {
            attackid: 'T1583.003',
            zhcn: '获取基础设施：虚拟专用服务器',
            id: 354
          },
          {
            attackid: 'T1583.004',
            zhcn: '获取基础设施：服务器',
            id: 355
          },
          {
            attackid: 'T1583.005',
            zhcn: '获取基础设施：僵尸网络',
            id: 356
          },
          {
            attackid: 'T1583.006',
            zhcn: '获取基础设施：网络服务',
            id: 357
          },
          {
            attackid: 'T1583.007',
            zhcn: '获取基础设施：无服务器',
            id: 358
          },
          {
            attackid: 'T1583.008',
            zhcn: '获取基础设施：恶意广告',
            id: 359
          }
        ]
      },
      {
        attackid: 'T1650',
        zhcn: '获取访问权限',
        id: 281,
        children: []
      }
    ]
  },
  {
    tacticid: 'TA0001',
    zhcn: '初始访问',
    attack_list: [
      {
        attackid: 'T1566',
        zhcn: '网络钓鱼',
        id: 290,
        children: [
          {
            attackid: 'T1566.001',
            zhcn: '网络钓鱼：鱼叉式网络钓鱼附件',
            id: 391
          },
          {
            attackid: 'T1566.002',
            zhcn: '网络钓鱼：鱼叉式网络钓鱼链接',
            id: 392
          },
          {
            attackid: 'T1566.003',
            zhcn: '网络钓鱼：通过服务进行的鱼叉式网络钓鱼',
            id: 393
          },
          {
            attackid: 'T1566.004',
            zhcn: '网络钓鱼：语音鱼叉式网络钓鱼',
            id: 394
          }
        ]
      },
      {
        attackid: 'T1659',
        zhcn: '内容注入',
        id: 289,
        children: []
      },
      {
        attackid: 'T1078',
        zhcn: '有效账户',
        id: 11,
        children: [
          {
            attackid: 'T1078.001',
            zhcn: '有效账户：默认账户',
            id: 398
          },
          {
            attackid: 'T1078.002',
            zhcn: '有效账户：域账户',
            id: 399
          },
          {
            attackid: 'T1078.003',
            zhcn: '有效账户：本地账户',
            id: 400
          },
          {
            attackid: 'T1078.004',
            zhcn: '有效账户：云账户',
            id: 401
          }
        ]
      },
      {
        attackid: 'T1199',
        zhcn: '可信关系',
        id: 10,
        children: []
      },
      {
        attackid: 'T1195',
        zhcn: '供应链攻击',
        id: 9,
        children: [
          {
            attackid: 'T1195.001',
            zhcn: '供应链攻击：受损的软件依赖项和开发工具',
            id: 395
          },
          {
            attackid: 'T1195.002',
            zhcn: '供应链攻击：受损的软件供应链',
            id: 396
          },
          {
            attackid: 'T1195.003',
            zhcn: '供应链攻击：受损的硬件供应链',
            id: 397
          }
        ]
      },
      {
        attackid: 'T1091',
        zhcn: '通过移动存储进行复制',
        id: 5,
        children: []
      },
      {
        attackid: 'T1200',
        zhcn: '硬件添加',
        id: 4,
        children: []
      },
      {
        attackid: 'T1133',
        zhcn: '外部远程服务',
        id: 3,
        children: []
      },
      {
        attackid: 'T1189',
        zhcn: '路过式攻击',
        id: 2,
        children: []
      },
      {
        attackid: 'T1190',
        zhcn: '面向公众应用的利用',
        id: 1,
        children: []
      }
    ]
  },
  {
    tacticid: 'TA0002',
    zhcn: '执行',
    attack_list: [
      {
        attackid: 'T1569',
        zhcn: '系统服务',
        id: 296,
        children: [
          {
            attackid: 'T1569.001',
            zhcn: '系统服务：Launchctl',
            id: 420
          },
          {
            attackid: 'T1569.002',
            zhcn: '系统服务：服务执行',
            id: 421
          }
        ]
      },
      {
        attackid: 'T1648',
        zhcn: '无服务器执行',
        id: 295,
        children: []
      },
      {
        attackid: 'T1559',
        zhcn: '进程间通信',
        id: 294,
        children: [
          {
            attackid: 'T1559.001',
            zhcn: '进程间通信：组件对象模型',
            id: 412
          },
          {
            attackid: 'T1559.002',
            zhcn: '进程间通信：动态数据交换',
            id: 413
          },
          {
            attackid: 'T1559.003',
            zhcn: '进程间通信：XPC 服务',
            id: 414
          }
        ]
      },
      {
        attackid: 'T1610',
        zhcn: '部署容器',
        id: 293,
        children: []
      },
      {
        attackid: 'T1609',
        zhcn: '容器管理命令',
        id: 292,
        children: []
      },
      {
        attackid: 'T1651',
        zhcn: '云管理命令',
        id: 291,
        children: []
      },
      {
        attackid: 'T1220',
        zhcn: 'XSL 脚本处理',
        id: 44,
        children: []
      },
      {
        attackid: 'T1047',
        zhcn: 'Windows 管理工具',
        id: 42,
        children: []
      },
      {
        attackid: 'T1204',
        zhcn: '用户执行',
        id: 41,
        children: [
          {
            attackid: 'T1204.001',
            zhcn: '用户执行：恶意链接',
            id: 422
          },
          {
            attackid: 'T1204.002',
            zhcn: '用户执行：恶意文件',
            id: 423
          },
          {
            attackid: 'T1204.003',
            zhcn: '用户执行：恶意映像',
            id: 424
          }
        ]
      },
      {
        attackid: 'T1072',
        zhcn: '软件部署工具',
        id: 38,
        children: []
      },
      {
        attackid: 'T1053',
        zhcn: '计划任务/作业',
        id: 31,
        children: [
          {
            attackid: 'T1053.002',
            zhcn: '计划任务/作业：At',
            id: 415
          },
          {
            attackid: 'T1053.003',
            zhcn: '计划任务/作业：Cron',
            id: 416
          },
          {
            attackid: 'T1053.005',
            zhcn: '计划任务/作业：计划任务',
            id: 417
          },
          {
            attackid: 'T1053.006',
            zhcn: '计划任务/作业：Systemd 计时器',
            id: 418
          },
          {
            attackid: 'T1053.007',
            zhcn: '计划任务/作业：容器编排作业',
            id: 419
          }
        ]
      },
      {
        attackid: 'T1203',
        zhcn: '客户端执行利用',
        id: 20,
        children: []
      },
      {
        attackid: 'T1129',
        zhcn: '共享模块',
        id: 19,
        children: []
      },
      {
        attackid: 'T1106',
        zhcn: '原生 API 接口',
        id: 18,
        children: []
      },
      {
        attackid: 'T1059',
        zhcn: '命令和脚本解释器',
        id: 14,
        children: [
          {
            attackid: 'T1059.001',
            zhcn: '命令和脚本解释器：PowerShell',
            id: 402
          },
          {
            attackid: 'T1059.002',
            zhcn: '命令和脚本解释器：AppleScript',
            id: 403
          },
          {
            attackid: 'T1059.003',
            zhcn: '命令和脚本解释器：Windows 命令外壳',
            id: 404
          },
          {
            attackid: 'T1059.004',
            zhcn: '命令和脚本解释器：Unix 外壳',
            id: 405
          },
          {
            attackid: 'T1059.005',
            zhcn: '命令和脚本解释器：Visual Basic',
            id: 406
          },
          {
            attackid: 'T1059.006',
            zhcn: '命令和脚本解释器：Python',
            id: 407
          },
          {
            attackid: 'T1059.007',
            zhcn: '命令和脚本解释器：JavaScript',
            id: 408
          },
          {
            attackid: 'T1059.008',
            zhcn: '命令和脚本解释器：网络设备命令行界面',
            id: 409
          },
          {
            attackid: 'T1059.009',
            zhcn: '命令和脚本解释器：云 API',
            id: 410
          },
          {
            attackid: 'T1059.010',
            zhcn: '命令和脚本解释器：AutoHotKey 和 AutoIT',
            id: 411
          },
          {
            attackid: 'T1059.011',
            zhcn: '命令和脚本解释器：Lua',
            id: 780
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0003',
    zhcn: '持久化',
    attack_list: [
      {
        attackid: 'T1542',
        zhcn: '操作系统前启动',
        id: 302,
        children: [
          {
            attackid: 'T1542.001',
            zhcn: '操作系统前启动：系统固件',
            id: 502
          },
          {
            attackid: 'T1542.002',
            zhcn: '操作系统前启动：组件固件',
            id: 503
          },
          {
            attackid: 'T1542.004',
            zhcn: '操作系统前启动： ROMMON 工具包',
            id: 504
          },
          {
            attackid: 'T1542.003',
            zhcn: '操作系统前启动：引导工具包',
            id: 505
          },
          {
            attackid: 'T1542.005',
            zhcn: '操作系统前启动：TFTP 引导',
            id: 506
          }
        ]
      },
      {
        attackid: 'T1653',
        zhcn: '电源设置',
        id: 301,
        children: []
      },
      {
        attackid: 'T1556',
        zhcn: '修改认证过程',
        id: 300,
        children: [
          {
            attackid: 'T1556.001',
            zhcn: '修改认证过程：域控制器认证',
            id: 487
          },
          {
            attackid: 'T1556.002',
            zhcn: '修改认证过程：密码筛选 DLL',
            id: 488
          },
          {
            attackid: 'T1556.003',
            zhcn: '修改认证过程：可插拔认证模块',
            id: 489
          },
          {
            attackid: 'T1556.004',
            zhcn: '修改认证过程：网络设备认证',
            id: 490
          },
          {
            attackid: 'T1556.005',
            zhcn: '修改认证过程：可逆加密',
            id: 491
          },
          {
            attackid: 'T1556.006',
            zhcn: '修改认证过程：多因素认证',
            id: 492
          },
          {
            attackid: 'T1556.007',
            zhcn: '修改认证过程：混合身份',
            id: 493
          },
          {
            attackid: 'T1556.008',
            zhcn: '修改认证过程：网络提供程序 DLL',
            id: 494
          },
          {
            attackid: 'T1556.009',
            zhcn: '修改认证过程：条件访问策略',
            id: 495
          }
        ]
      },
      {
        attackid: 'T1546',
        zhcn: '事件触发执行',
        id: 299,
        children: [
          {
            attackid: 'T1546.001',
            zhcn: '事件触发执行：更改默认文件关联',
            id: 458
          },
          {
            attackid: 'T1546.002',
            zhcn: '事件触发执行：屏幕保护程序',
            id: 459
          },
          {
            attackid: 'T1546.003',
            zhcn: '事件触发执行：Windows 管理工具事件订阅',
            id: 460
          },
          {
            attackid: 'T1546.004',
            zhcn: '事件触发执行：Unix 外壳配置修改',
            id: 461
          },
          {
            attackid: 'T1546.005',
            zhcn: '事件触发执行：陷阱',
            id: 462
          },
          {
            attackid: 'T1546.006',
            zhcn: '事件触发执行：LC_LOAD_DYLIB 附加',
            id: 463
          },
          {
            attackid: 'T1546.007',
            zhcn: '事件触发执行：Netsh Helper DLL',
            id: 464
          },
          {
            attackid: 'T1546.008',
            zhcn: '事件触发执行：辅助功能',
            id: 465
          },
          {
            attackid: 'T1546.009',
            zhcn: '事件触发执行：AppCert DLL',
            id: 466
          },
          {
            attackid: 'T1546.010',
            zhcn: '事件触发执行：AppInit DLL',
            id: 467
          },
          {
            attackid: 'T1546.011',
            zhcn: '事件触发执行：应用程序垫片',
            id: 468
          },
          {
            attackid: 'T1546.012',
            zhcn: '事件触发执行：映像文件执行选项注入',
            id: 469
          },
          {
            attackid: 'T1546.013',
            zhcn: '事件触发执行：PowerShell 配置文件',
            id: 470
          },
          {
            attackid: 'T1546.014',
            zhcn: '事件触发执行：Emond',
            id: 471
          },
          {
            attackid: 'T1546.015',
            zhcn: '事件触发执行：组件对象模型劫持',
            id: 472
          },
          {
            attackid: 'T1546.016',
            zhcn: '事件触发执行：安装程序包',
            id: 473
          },
          {
            attackid: 'T1546.017',
            zhcn: '事件触发执行：Udev 规则',
            id: 784
          }
        ]
      },
      {
        attackid: 'T1554',
        zhcn: '破坏主机软件二进制文件',
        id: 298,
        children: []
      },
      {
        attackid: 'T1547',
        zhcn: '启动或登录自动启动执行',
        id: 297,
        children: [
          {
            attackid: 'T1547.001',
            zhcn: '启动或登录自动启动执行：注册表运行键/启动文件夹',
            id: 431
          },
          {
            attackid: 'T1547.002',
            zhcn: '启动或登录自动启动执行：身份验证包',
            id: 432
          },
          {
            attackid: 'T1547.003',
            zhcn: '启动或登录自动启动执行：时间提供程序',
            id: 433
          },
          {
            attackid: 'T1547.004',
            zhcn: '启动或登录自动启动执行：Winlogon Helper DLL',
            id: 434
          },
          {
            attackid: 'T1547.005',
            zhcn: '启动或登录自动启动执行：安全支持提供程序',
            id: 435
          },
          {
            attackid: 'T1547.006',
            zhcn: '启动或登录自动启动执行：内核模块和扩展',
            id: 436
          },
          {
            attackid: 'T1547.007',
            zhcn: '启动或登录自动启动执行：重新打开的应用程序',
            id: 437
          },
          {
            attackid: 'T1547.008',
            zhcn: '启动或登录自动启动执行：LSASS 驱动程序',
            id: 438
          },
          {
            attackid: 'T1547.009',
            zhcn: '启动或登录自动启动执行：快捷方式修改',
            id: 439
          },
          {
            attackid: 'T1547.010',
            zhcn: '启动或登录自动启动执行：端口监视器',
            id: 440
          },
          {
            attackid: 'T1547.012',
            zhcn: '启动或登录自动启动执行：打印处理器',
            id: 441
          },
          {
            attackid: 'T1547.013',
            zhcn: '启动或登录自动启动执行：XDG 自动启动条目',
            id: 442
          },
          {
            attackid: 'T1547.014',
            zhcn: '启动或登录自动启动执行：活动安装',
            id: 443
          },
          {
            attackid: 'T1547.015',
            zhcn: '启动或登录自动启动执行：登录项',
            id: 444
          }
        ]
      },
      {
        attackid: 'T1574',
        zhcn: '劫持执行流程',
        id: 268,
        children: [
          {
            attackid: 'T1574.001',
            zhcn: '劫持执行流程：DLL 搜索顺序劫持',
            id: 474
          },
          {
            attackid: 'T1574.002',
            zhcn: '劫持执行流程：DLL 侧载',
            id: 475
          },
          {
            attackid: 'T1574.004',
            zhcn: '劫持执行流程：Dylib 劫持',
            id: 476
          },
          {
            attackid: 'T1574.005',
            zhcn: '劫持执行流程：可执行安装程序文件权限弱点',
            id: 477
          },
          {
            attackid: 'T1574.006',
            zhcn: '劫持执行流程：动态链接器劫持',
            id: 478
          },
          {
            attackid: 'T1574.007',
            zhcn: '劫持执行流程：通过 PATH 环境变量进行路径拦截',
            id: 479
          },
          {
            attackid: 'T1574.008',
            zhcn: '劫持执行流程：通过搜索顺序劫持进行路径拦截',
            id: 480
          },
          {
            attackid: 'T1574.009',
            zhcn: '劫持执行流程：通过未加引号的路径进行路径拦截',
            id: 481
          },
          {
            attackid: 'T1574.010',
            zhcn: '劫持执行流程：服务文件权限弱点',
            id: 482
          },
          {
            attackid: 'T1574.011',
            zhcn: '劫持执行流程：服务注册表权限弱点',
            id: 483
          },
          {
            attackid: 'T1574.012',
            zhcn: '劫持执行流程：COR_PROFILER',
            id: 484
          },
          {
            attackid: 'T1574.013',
            zhcn: '劫持执行流程：内核回调表',
            id: 485
          },
          {
            attackid: 'T1574.014',
            zhcn: '劫持执行流程：应用程序域管理器',
            id: 486
          }
        ]
      },
      {
        attackid: 'T1543',
        zhcn: '创建或修改系统进程',
        id: 267,
        children: [
          {
            attackid: 'T1543.001',
            zhcn: '创建或修改系统进程：启动代理',
            id: 453
          },
          {
            attackid: 'T1543.002',
            zhcn: '创建或修改系统进程：Systemd 服务',
            id: 454
          },
          {
            attackid: 'T1543.003',
            zhcn: '创建或修改系统进程：Windows 服务',
            id: 455
          },
          {
            attackid: 'T1543.004',
            zhcn: '创建或修改系统进程：启动守护进程',
            id: 456
          },
          {
            attackid: 'T1543.005',
            zhcn: '创建或修改系统进程：容器服务',
            id: 457
          }
        ]
      },
      {
        attackid: 'T1505',
        zhcn: '服务器软件组件',
        id: 91,
        children: [
          {
            attackid: 'T1505.001',
            zhcn: '服务器软件组件：SQL 存储过程',
            id: 507
          },
          {
            attackid: 'T1505.002',
            zhcn: '服务器软件组件：传输代理',
            id: 508
          },
          {
            attackid: 'T1505.003',
            zhcn: '服务器软件组件：网页后门',
            id: 509
          },
          {
            attackid: 'T1505.004',
            zhcn: '服务器软件组件：IIS 组件',
            id: 510
          },
          {
            attackid: 'T1505.005',
            zhcn: '服务器软件组件：终端服务 DLL',
            id: 511
          }
        ]
      },
      {
        attackid: 'T1205',
        zhcn: '流量信号',
        id: 82,
        children: [
          {
            attackid: 'T1205.001',
            zhcn: '流量信号：端口敲门',
            id: 512
          },
          {
            attackid: 'T1205.002',
            zhcn: '流量信号：套接字过滤器',
            id: 513
          }
        ]
      },
      {
        attackid: 'T1137',
        zhcn: 'Office 应用程序启动',
        id: 79,
        children: [
          {
            attackid: 'T1137.001',
            zhcn: 'Office 应用程序启动：Office 模板宏',
            id: 496
          },
          {
            attackid: 'T1137.002',
            zhcn: 'Office 应用程序启动：Office 测试',
            id: 497
          },
          {
            attackid: 'T1137.003',
            zhcn: 'Office 应用程序启动：Outlook 表单',
            id: 498
          },
          {
            attackid: 'T1137.004',
            zhcn: 'Office 应用程序启动：Outlook 主页',
            id: 499
          },
          {
            attackid: 'T1137.005',
            zhcn: 'Office 应用程序启动：Outlook 规则',
            id: 500
          },
          {
            attackid: 'T1137.006',
            zhcn: 'Office 应用程序启动：加载项',
            id: 501
          }
        ]
      },
      {
        attackid: 'T1037',
        zhcn: '启动或登录初始化脚本',
        id: 75,
        children: [
          {
            attackid: 'T1037.001',
            zhcn: '启动或登录初始化脚本：登录脚本（Windows）',
            id: 445
          },
          {
            attackid: 'T1037.002',
            zhcn: '启动或登录初始化脚本：登录钩子',
            id: 446
          },
          {
            attackid: 'T1037.003',
            zhcn: '启动或登录初始化脚本：网络登录脚本',
            id: 447
          },
          {
            attackid: 'T1037.004',
            zhcn: '启动或登录初始化脚本：RC 脚本',
            id: 448
          },
          {
            attackid: 'T1037.005',
            zhcn: '启动或登录初始化脚本：启动项',
            id: 449
          }
        ]
      },
      {
        attackid: 'T1525',
        zhcn: '植入内部镜像',
        id: 69,
        children: []
      },
      {
        attackid: 'T1136',
        zhcn: '创建账户',
        id: 60,
        children: [
          {
            attackid: 'T1136.001',
            zhcn: '创建账户：本地账户',
            id: 450
          },
          {
            attackid: 'T1136.002',
            zhcn: '创建账户：域账户',
            id: 451
          },
          {
            attackid: 'T1136.003',
            zhcn: '创建账户：云账户',
            id: 452
          }
        ]
      },
      {
        attackid: 'T1176',
        zhcn: '浏览器扩展',
        id: 56,
        children: []
      },
      {
        attackid: 'T1197',
        zhcn: 'BITS 作业',
        id: 54,
        children: []
      },
      {
        attackid: 'T1098',
        zhcn: '账户操纵',
        id: 49,
        children: [
          {
            attackid: 'T1098.001',
            zhcn: '账户操纵：额外的云凭证',
            id: 425
          },
          {
            attackid: 'T1098.002',
            zhcn: '账户操纵：额外的电子邮件委托权限',
            id: 426
          },
          {
            attackid: 'T1098.003',
            zhcn: '账户操纵：额外的云角色',
            id: 427
          },
          {
            attackid: 'T1098.004',
            zhcn: '账户操纵：SSH 授权密钥',
            id: 428
          },
          {
            attackid: 'T1098.005',
            zhcn: '账户操纵：设备注册',
            id: 429
          },
          {
            attackid: 'T1098.006',
            zhcn: '账户操纵：额外的容器集群角色',
            id: 430
          },
          {
            attackid: 'T1098.007',
            zhcn: '账户操纵：其他本地或域组',
            id: 777
          }
        ]
      },
      {
        attackid: 'T1053',
        zhcn: '计划任务/作业',
        id: 31,
        children: [
          {
            attackid: 'T1053.002',
            zhcn: '计划任务/作业：At',
            id: 415
          },
          {
            attackid: 'T1053.003',
            zhcn: '计划任务/作业：Cron',
            id: 416
          },
          {
            attackid: 'T1053.005',
            zhcn: '计划任务/作业：计划任务',
            id: 417
          },
          {
            attackid: 'T1053.006',
            zhcn: '计划任务/作业：Systemd 计时器',
            id: 418
          },
          {
            attackid: 'T1053.007',
            zhcn: '计划任务/作业：容器编排作业',
            id: 419
          }
        ]
      },
      {
        attackid: 'T1078',
        zhcn: '有效账户',
        id: 11,
        children: [
          {
            attackid: 'T1078.001',
            zhcn: '有效账户：默认账户',
            id: 398
          },
          {
            attackid: 'T1078.002',
            zhcn: '有效账户：域账户',
            id: 399
          },
          {
            attackid: 'T1078.003',
            zhcn: '有效账户：本地账户',
            id: 400
          },
          {
            attackid: 'T1078.004',
            zhcn: '有效账户：云账户',
            id: 401
          }
        ]
      },
      {
        attackid: 'T1133',
        zhcn: '外部远程服务',
        id: 3,
        children: []
      }
    ]
  },
  {
    tacticid: 'TA0004',
    zhcn: '权限升级',
    attack_list: [
      {
        attackid: 'T1611',
        zhcn: '逃逸到主机',
        id: 304,
        children: []
      },
      {
        attackid: 'T1548',
        zhcn: '滥用提升控制机制',
        id: 303,
        children: [
          {
            attackid: 'T1548.001',
            zhcn: '滥用提升控制机制：Setuid 和 Setgid',
            id: 514
          },
          {
            attackid: 'T1548.002',
            zhcn: '滥用提升控制机制：绕过用户账户控制',
            id: 515
          },
          {
            attackid: 'T1548.003',
            zhcn: '滥用提升控制机制：Sudo 和 Sudo 缓存',
            id: 516
          },
          {
            attackid: 'T1548.004',
            zhcn: '滥用提升控制机制：带提示的提升执行',
            id: 517
          },
          {
            attackid: 'T1548.005',
            zhcn: '滥用提升控制机制：临时提升的云访问权限',
            id: 518
          },
          {
            attackid: 'T1548.006',
            zhcn: '滥用提升控制机制：TCC 操纵',
            id: 519
          }
        ]
      },
      {
        attackid: 'T1546',
        zhcn: '事件触发执行',
        id: 299,
        children: [
          {
            attackid: 'T1546.001',
            zhcn: '事件触发执行：更改默认文件关联',
            id: 458
          },
          {
            attackid: 'T1546.002',
            zhcn: '事件触发执行：屏幕保护程序',
            id: 459
          },
          {
            attackid: 'T1546.003',
            zhcn: '事件触发执行：Windows 管理工具事件订阅',
            id: 460
          },
          {
            attackid: 'T1546.004',
            zhcn: '事件触发执行：Unix 外壳配置修改',
            id: 461
          },
          {
            attackid: 'T1546.005',
            zhcn: '事件触发执行：陷阱',
            id: 462
          },
          {
            attackid: 'T1546.006',
            zhcn: '事件触发执行：LC_LOAD_DYLIB 附加',
            id: 463
          },
          {
            attackid: 'T1546.007',
            zhcn: '事件触发执行：Netsh Helper DLL',
            id: 464
          },
          {
            attackid: 'T1546.008',
            zhcn: '事件触发执行：辅助功能',
            id: 465
          },
          {
            attackid: 'T1546.009',
            zhcn: '事件触发执行：AppCert DLL',
            id: 466
          },
          {
            attackid: 'T1546.010',
            zhcn: '事件触发执行：AppInit DLL',
            id: 467
          },
          {
            attackid: 'T1546.011',
            zhcn: '事件触发执行：应用程序垫片',
            id: 468
          },
          {
            attackid: 'T1546.012',
            zhcn: '事件触发执行：映像文件执行选项注入',
            id: 469
          },
          {
            attackid: 'T1546.013',
            zhcn: '事件触发执行：PowerShell 配置文件',
            id: 470
          },
          {
            attackid: 'T1546.014',
            zhcn: '事件触发执行：Emond',
            id: 471
          },
          {
            attackid: 'T1546.015',
            zhcn: '事件触发执行：组件对象模型劫持',
            id: 472
          },
          {
            attackid: 'T1546.016',
            zhcn: '事件触发执行：安装程序包',
            id: 473
          },
          {
            attackid: 'T1546.017',
            zhcn: '事件触发执行：Udev 规则',
            id: 784
          }
        ]
      },
      {
        attackid: 'T1547',
        zhcn: '启动或登录自动启动执行',
        id: 297,
        children: [
          {
            attackid: 'T1547.001',
            zhcn: '启动或登录自动启动执行：注册表运行键/启动文件夹',
            id: 431
          },
          {
            attackid: 'T1547.002',
            zhcn: '启动或登录自动启动执行：身份验证包',
            id: 432
          },
          {
            attackid: 'T1547.003',
            zhcn: '启动或登录自动启动执行：时间提供程序',
            id: 433
          },
          {
            attackid: 'T1547.004',
            zhcn: '启动或登录自动启动执行：Winlogon Helper DLL',
            id: 434
          },
          {
            attackid: 'T1547.005',
            zhcn: '启动或登录自动启动执行：安全支持提供程序',
            id: 435
          },
          {
            attackid: 'T1547.006',
            zhcn: '启动或登录自动启动执行：内核模块和扩展',
            id: 436
          },
          {
            attackid: 'T1547.007',
            zhcn: '启动或登录自动启动执行：重新打开的应用程序',
            id: 437
          },
          {
            attackid: 'T1547.008',
            zhcn: '启动或登录自动启动执行：LSASS 驱动程序',
            id: 438
          },
          {
            attackid: 'T1547.009',
            zhcn: '启动或登录自动启动执行：快捷方式修改',
            id: 439
          },
          {
            attackid: 'T1547.010',
            zhcn: '启动或登录自动启动执行：端口监视器',
            id: 440
          },
          {
            attackid: 'T1547.012',
            zhcn: '启动或登录自动启动执行：打印处理器',
            id: 441
          },
          {
            attackid: 'T1547.013',
            zhcn: '启动或登录自动启动执行：XDG 自动启动条目',
            id: 442
          },
          {
            attackid: 'T1547.014',
            zhcn: '启动或登录自动启动执行：活动安装',
            id: 443
          },
          {
            attackid: 'T1547.015',
            zhcn: '启动或登录自动启动执行：登录项',
            id: 444
          }
        ]
      },
      {
        attackid: 'T1574',
        zhcn: '劫持执行流程',
        id: 268,
        children: [
          {
            attackid: 'T1574.001',
            zhcn: '劫持执行流程：DLL 搜索顺序劫持',
            id: 474
          },
          {
            attackid: 'T1574.002',
            zhcn: '劫持执行流程：DLL 侧载',
            id: 475
          },
          {
            attackid: 'T1574.004',
            zhcn: '劫持执行流程：Dylib 劫持',
            id: 476
          },
          {
            attackid: 'T1574.005',
            zhcn: '劫持执行流程：可执行安装程序文件权限弱点',
            id: 477
          },
          {
            attackid: 'T1574.006',
            zhcn: '劫持执行流程：动态链接器劫持',
            id: 478
          },
          {
            attackid: 'T1574.007',
            zhcn: '劫持执行流程：通过 PATH 环境变量进行路径拦截',
            id: 479
          },
          {
            attackid: 'T1574.008',
            zhcn: '劫持执行流程：通过搜索顺序劫持进行路径拦截',
            id: 480
          },
          {
            attackid: 'T1574.009',
            zhcn: '劫持执行流程：通过未加引号的路径进行路径拦截',
            id: 481
          },
          {
            attackid: 'T1574.010',
            zhcn: '劫持执行流程：服务文件权限弱点',
            id: 482
          },
          {
            attackid: 'T1574.011',
            zhcn: '劫持执行流程：服务注册表权限弱点',
            id: 483
          },
          {
            attackid: 'T1574.012',
            zhcn: '劫持执行流程：COR_PROFILER',
            id: 484
          },
          {
            attackid: 'T1574.013',
            zhcn: '劫持执行流程：内核回调表',
            id: 485
          },
          {
            attackid: 'T1574.014',
            zhcn: '劫持执行流程：应用程序域管理器',
            id: 486
          }
        ]
      },
      {
        attackid: 'T1543',
        zhcn: '创建或修改系统进程',
        id: 267,
        children: [
          {
            attackid: 'T1543.001',
            zhcn: '创建或修改系统进程：启动代理',
            id: 453
          },
          {
            attackid: 'T1543.002',
            zhcn: '创建或修改系统进程：Systemd 服务',
            id: 454
          },
          {
            attackid: 'T1543.003',
            zhcn: '创建或修改系统进程：Windows 服务',
            id: 455
          },
          {
            attackid: 'T1543.004',
            zhcn: '创建或修改系统进程：启动守护进程',
            id: 456
          },
          {
            attackid: 'T1543.005',
            zhcn: '创建或修改系统进程：容器服务',
            id: 457
          }
        ]
      },
      {
        attackid: 'T1484',
        zhcn: '域或租户策略修改',
        id: 128,
        children: [
          {
            attackid: 'T1484.001',
            zhcn: '域或租户策略修改：组策略修改',
            id: 525
          },
          {
            attackid: 'T1484.002',
            zhcn: '域或租户策略修改：信任修改',
            id: 526
          }
        ]
      },
      {
        attackid: 'T1055',
        zhcn: '进程注入',
        id: 108,
        children: [
          {
            attackid: 'T1055.001',
            zhcn: '进程注入：动态链接库注入',
            id: 527
          },
          {
            attackid: 'T1055.002',
            zhcn: '进程注入：可移植可执行文件注入',
            id: 528
          },
          {
            attackid: 'T1055.003',
            zhcn: '进程注入：线程执行劫持',
            id: 529
          },
          {
            attackid: 'T1055.004',
            zhcn: '进程注入：异步过程调用',
            id: 530
          },
          {
            attackid: 'T1055.005',
            zhcn: '进程注入：线程本地存储',
            id: 531
          },
          {
            attackid: 'T1055.008',
            zhcn: '进程注入：Ptrace 系统调用',
            id: 532
          },
          {
            attackid: 'T1055.009',
            zhcn: '进程注入：进程内存',
            id: 533
          },
          {
            attackid: 'T1055.011',
            zhcn: '进程注入：额外窗口内存注入',
            id: 534
          },
          {
            attackid: 'T1055.012',
            zhcn: '进程注入：进程掏空',
            id: 535
          },
          {
            attackid: 'T1055.013',
            zhcn: '进程注入：进程替身',
            id: 536
          },
          {
            attackid: 'T1055.014',
            zhcn: '进程注入：VDSO 劫持',
            id: 537
          },
          {
            attackid: 'T1055.015',
            zhcn: '进程注入：列表植入',
            id: 538
          }
        ]
      },
      {
        attackid: 'T1068',
        zhcn: '提权利用',
        id: 105,
        children: []
      },
      {
        attackid: 'T1134',
        zhcn: '访问令牌操纵',
        id: 102,
        children: [
          {
            attackid: 'T1134.001',
            zhcn: '访问令牌操纵：令牌模拟/窃取',
            id: 520
          },
          {
            attackid: 'T1134.002',
            zhcn: '访问令牌操纵：用令牌创建进程',
            id: 521
          },
          {
            attackid: 'T1134.003',
            zhcn: '访问令牌操纵：创建和模拟令牌',
            id: 522
          },
          {
            attackid: 'T1134.004',
            zhcn: '访问令牌操纵：父进程 ID 欺骗',
            id: 523
          },
          {
            attackid: 'T1134.005',
            zhcn: '访问令牌操纵：SID-History 注入',
            id: 524
          }
        ]
      },
      {
        attackid: 'T1037',
        zhcn: '启动或登录初始化脚本',
        id: 75,
        children: [
          {
            attackid: 'T1037.001',
            zhcn: '启动或登录初始化脚本：登录脚本（Windows）',
            id: 445
          },
          {
            attackid: 'T1037.002',
            zhcn: '启动或登录初始化脚本：登录钩子',
            id: 446
          },
          {
            attackid: 'T1037.003',
            zhcn: '启动或登录初始化脚本：网络登录脚本',
            id: 447
          },
          {
            attackid: 'T1037.004',
            zhcn: '启动或登录初始化脚本：RC 脚本',
            id: 448
          },
          {
            attackid: 'T1037.005',
            zhcn: '启动或登录初始化脚本：启动项',
            id: 449
          }
        ]
      },
      {
        attackid: 'T1098',
        zhcn: '账户操纵',
        id: 49,
        children: [
          {
            attackid: 'T1098.001',
            zhcn: '账户操纵：额外的云凭证',
            id: 425
          },
          {
            attackid: 'T1098.002',
            zhcn: '账户操纵：额外的电子邮件委托权限',
            id: 426
          },
          {
            attackid: 'T1098.003',
            zhcn: '账户操纵：额外的云角色',
            id: 427
          },
          {
            attackid: 'T1098.004',
            zhcn: '账户操纵：SSH 授权密钥',
            id: 428
          },
          {
            attackid: 'T1098.005',
            zhcn: '账户操纵：设备注册',
            id: 429
          },
          {
            attackid: 'T1098.006',
            zhcn: '账户操纵：额外的容器集群角色',
            id: 430
          },
          {
            attackid: 'T1098.007',
            zhcn: '账户操纵：其他本地或域组',
            id: 777
          }
        ]
      },
      {
        attackid: 'T1053',
        zhcn: '计划任务/作业',
        id: 31,
        children: [
          {
            attackid: 'T1053.002',
            zhcn: '计划任务/作业：At',
            id: 415
          },
          {
            attackid: 'T1053.003',
            zhcn: '计划任务/作业：Cron',
            id: 416
          },
          {
            attackid: 'T1053.005',
            zhcn: '计划任务/作业：计划任务',
            id: 417
          },
          {
            attackid: 'T1053.006',
            zhcn: '计划任务/作业：Systemd 计时器',
            id: 418
          },
          {
            attackid: 'T1053.007',
            zhcn: '计划任务/作业：容器编排作业',
            id: 419
          }
        ]
      },
      {
        attackid: 'T1078',
        zhcn: '有效账户',
        id: 11,
        children: [
          {
            attackid: 'T1078.001',
            zhcn: '有效账户：默认账户',
            id: 398
          },
          {
            attackid: 'T1078.002',
            zhcn: '有效账户：域账户',
            id: 399
          },
          {
            attackid: 'T1078.003',
            zhcn: '有效账户：本地账户',
            id: 400
          },
          {
            attackid: 'T1078.004',
            zhcn: '有效账户：云账户',
            id: 401
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0005',
    zhcn: '防御逃避',
    attack_list: [
      {
        attackid: 'T1666',
        zhcn: '修改云资源层次结构',
        id: 788,
        children: []
      },
      {
        attackid: 'T1600',
        zhcn: '削弱加密',
        id: 317,
        children: [
          {
            attackid: 'T1600.001',
            zhcn: '削弱加密：减小密钥空间',
            id: 634
          },
          {
            attackid: 'T1600.002',
            zhcn: '削弱加密：禁用加密硬件',
            id: 635
          }
        ]
      },
      {
        attackid: 'T1550',
        zhcn: '使用替代身份验证材料',
        id: 316,
        children: [
          {
            attackid: 'T1550.001',
            zhcn: '使用替代身份验证材料：应用程序访问令牌',
            id: 627
          },
          {
            attackid: 'T1550.002',
            zhcn: '使用替代身份验证材料：传递哈希',
            id: 628
          },
          {
            attackid: 'T1550.003',
            zhcn: '使用替代身份验证材料：传递票据',
            id: 629
          },
          {
            attackid: 'T1550.004',
            zhcn: '使用替代身份验证材料：Web 会话 Cookie',
            id: 630
          }
        ]
      },
      {
        attackid: 'T1553',
        zhcn: '破坏信任控制',
        id: 315,
        children: [
          {
            attackid: 'T1553.001',
            zhcn: '破坏信任控制：Gatekeeper 绕过',
            id: 604
          },
          {
            attackid: 'T1553.002',
            zhcn: '破坏信任控制：代码签名',
            id: 605
          },
          {
            attackid: 'T1553.003',
            zhcn: '破坏信任控制：系统完整性保护（SIP）和信任提供程序劫持',
            id: 606
          },
          {
            attackid: 'T1553.004',
            zhcn: '破坏信任控制：安装根证书',
            id: 607
          },
          {
            attackid: 'T1553.005',
            zhcn: '破坏信任控制：网页标记绕过',
            id: 608
          },
          {
            attackid: 'T1553.006',
            zhcn: '破坏信任控制：代码签名策略修改',
            id: 609
          }
        ]
      },
      {
        attackid: 'T1620',
        zhcn: '反射式代码加载',
        id: 314,
        children: []
      },
      {
        attackid: 'T1647',
        zhcn: 'Plist 文件修改',
        id: 313,
        children: []
      },
      {
        attackid: 'T1599',
        zhcn: '网络边界桥接',
        id: 312,
        children: [
          {
            attackid: 'T1599.001',
            zhcn: '网络边界桥接：网络地址转换穿越',
            id: 590
          }
        ]
      },
      {
        attackid: 'T1601',
        zhcn: '修改系统映像',
        id: 311,
        children: [
          {
            attackid: 'T1601.001',
            zhcn: '修改系统映像：修补系统映像',
            id: 588
          },
          {
            attackid: 'T1601.002',
            zhcn: '修改系统映像：降级系统映像',
            id: 589
          }
        ]
      },
      {
        attackid: 'T1578',
        zhcn: '修改云计算基础设施',
        id: 310,
        children: [
          {
            attackid: 'T1578.001',
            zhcn: '修改云计算基础设施：创建快照',
            id: 583
          },
          {
            attackid: 'T1578.002',
            zhcn: '修改云计算基础设施：创建云实例',
            id: 584
          },
          {
            attackid: 'T1578.003',
            zhcn: '修改云计算基础设施：删除云实例',
            id: 585
          },
          {
            attackid: 'T1578.004',
            zhcn: '修改云计算基础设施：还原云实例',
            id: 586
          },
          {
            attackid: 'T1578.005',
            zhcn: '修改云计算基础设施：修改云计算配置',
            id: 587
          }
        ]
      },
      {
        attackid: 'T1656',
        zhcn: '冒充',
        id: 309,
        children: []
      },
      {
        attackid: 'T1562',
        zhcn: '削弱防御',
        id: 308,
        children: [
          {
            attackid: 'T1562.001',
            zhcn: '削弱防御：禁用或修改工具',
            id: 554
          },
          {
            attackid: 'T1562.002',
            zhcn: '削弱防御：禁用 Windows 事件日志记录',
            id: 555
          },
          {
            attackid: 'T1562.003',
            zhcn: '削弱防御：削弱命令历史记录日志',
            id: 556
          },
          {
            attackid: 'T1562.004',
            zhcn: '削弱防御：禁用或修改系统防火墙',
            id: 557
          },
          {
            attackid: 'T1562.006',
            zhcn: '削弱防御：指标拦截',
            id: 558
          },
          {
            attackid: 'T1562.007',
            zhcn: '削弱防御：禁用或修改云防火墙',
            id: 559
          },
          {
            attackid: 'T1562.008',
            zhcn: '削弱防御：禁用或修改云日志',
            id: 560
          },
          {
            attackid: 'T1562.009',
            zhcn: '削弱防御：安全模式启动',
            id: 561
          },
          {
            attackid: 'T1562.010',
            zhcn: '削弱防御：降级攻击',
            id: 562
          },
          {
            attackid: 'T1562.011',
            zhcn: '削弱防御：伪造安全警报',
            id: 563
          },
          {
            attackid: 'T1562.012',
            zhcn: '削弱防御：禁用或修改 Linux 审计系统',
            id: 564
          }
        ]
      },
      {
        attackid: 'T1564',
        zhcn: '隐藏工件',
        id: 307,
        children: [
          {
            attackid: 'T1564.001',
            zhcn: '隐藏工件：隐藏文件和目录',
            id: 542
          },
          {
            attackid: 'T1564.002',
            zhcn: '隐藏工件：隐藏用户',
            id: 543
          },
          {
            attackid: 'T1564.003',
            zhcn: '隐藏工件：隐藏窗口',
            id: 544
          },
          {
            attackid: 'T1564.004',
            zhcn: '隐藏工件：NTFS 文件属性',
            id: 545
          },
          {
            attackid: 'T1564.005',
            zhcn: '隐藏工件：隐藏文件系统',
            id: 546
          },
          {
            attackid: 'T1564.006',
            zhcn: '隐藏工件：运行虚拟实例',
            id: 547
          },
          {
            attackid: 'T1564.007',
            zhcn: '隐藏工件：VBA 重写',
            id: 548
          },
          {
            attackid: 'T1564.008',
            zhcn: '隐藏工件：电子邮件隐藏规则',
            id: 549
          },
          {
            attackid: 'T1564.009',
            zhcn: '隐藏工件：资源分叉',
            id: 550
          },
          {
            attackid: 'T1564.010',
            zhcn: '隐藏工件：进程参数欺骗',
            id: 551
          },
          {
            attackid: 'T1564.011',
            zhcn: '隐藏工件：忽略进程中断',
            id: 552
          },
          {
            attackid: 'T1564.012',
            zhcn: '隐藏工件：文件/路径排除',
            id: 553
          }
        ]
      },
      {
        attackid: 'T1622',
        zhcn: '调试器逃避',
        id: 306,
        children: []
      },
      {
        attackid: 'T1612',
        zhcn: '在主机上构建映像',
        id: 305,
        children: []
      },
      {
        attackid: 'T1548',
        zhcn: '滥用提升控制机制',
        id: 303,
        children: [
          {
            attackid: 'T1548.001',
            zhcn: '滥用提升控制机制：Setuid 和 Setgid',
            id: 514
          },
          {
            attackid: 'T1548.002',
            zhcn: '滥用提升控制机制：绕过用户账户控制',
            id: 515
          },
          {
            attackid: 'T1548.003',
            zhcn: '滥用提升控制机制：Sudo 和 Sudo 缓存',
            id: 516
          },
          {
            attackid: 'T1548.004',
            zhcn: '滥用提升控制机制：带提示的提升执行',
            id: 517
          },
          {
            attackid: 'T1548.005',
            zhcn: '滥用提升控制机制：临时提升的云访问权限',
            id: 518
          },
          {
            attackid: 'T1548.006',
            zhcn: '滥用提升控制机制：TCC 操纵',
            id: 519
          }
        ]
      },
      {
        attackid: 'T1542',
        zhcn: '操作系统前启动',
        id: 302,
        children: [
          {
            attackid: 'T1542.001',
            zhcn: '操作系统前启动：系统固件',
            id: 502
          },
          {
            attackid: 'T1542.002',
            zhcn: '操作系统前启动：组件固件',
            id: 503
          },
          {
            attackid: 'T1542.004',
            zhcn: '操作系统前启动： ROMMON 工具包',
            id: 504
          },
          {
            attackid: 'T1542.003',
            zhcn: '操作系统前启动：引导工具包',
            id: 505
          },
          {
            attackid: 'T1542.005',
            zhcn: '操作系统前启动：TFTP 引导',
            id: 506
          }
        ]
      },
      {
        attackid: 'T1556',
        zhcn: '修改认证过程',
        id: 300,
        children: [
          {
            attackid: 'T1556.001',
            zhcn: '修改认证过程：域控制器认证',
            id: 487
          },
          {
            attackid: 'T1556.002',
            zhcn: '修改认证过程：密码筛选 DLL',
            id: 488
          },
          {
            attackid: 'T1556.003',
            zhcn: '修改认证过程：可插拔认证模块',
            id: 489
          },
          {
            attackid: 'T1556.004',
            zhcn: '修改认证过程：网络设备认证',
            id: 490
          },
          {
            attackid: 'T1556.005',
            zhcn: '修改认证过程：可逆加密',
            id: 491
          },
          {
            attackid: 'T1556.006',
            zhcn: '修改认证过程：多因素认证',
            id: 492
          },
          {
            attackid: 'T1556.007',
            zhcn: '修改认证过程：混合身份',
            id: 493
          },
          {
            attackid: 'T1556.008',
            zhcn: '修改认证过程：网络提供程序 DLL',
            id: 494
          },
          {
            attackid: 'T1556.009',
            zhcn: '修改认证过程：条件访问策略',
            id: 495
          }
        ]
      },
      {
        attackid: 'T1610',
        zhcn: '部署容器',
        id: 293,
        children: []
      },
      {
        attackid: 'T1574',
        zhcn: '劫持执行流程',
        id: 268,
        children: [
          {
            attackid: 'T1574.001',
            zhcn: '劫持执行流程：DLL 搜索顺序劫持',
            id: 474
          },
          {
            attackid: 'T1574.002',
            zhcn: '劫持执行流程：DLL 侧载',
            id: 475
          },
          {
            attackid: 'T1574.004',
            zhcn: '劫持执行流程：Dylib 劫持',
            id: 476
          },
          {
            attackid: 'T1574.005',
            zhcn: '劫持执行流程：可执行安装程序文件权限弱点',
            id: 477
          },
          {
            attackid: 'T1574.006',
            zhcn: '劫持执行流程：动态链接器劫持',
            id: 478
          },
          {
            attackid: 'T1574.007',
            zhcn: '劫持执行流程：通过 PATH 环境变量进行路径拦截',
            id: 479
          },
          {
            attackid: 'T1574.008',
            zhcn: '劫持执行流程：通过搜索顺序劫持进行路径拦截',
            id: 480
          },
          {
            attackid: 'T1574.009',
            zhcn: '劫持执行流程：通过未加引号的路径进行路径拦截',
            id: 481
          },
          {
            attackid: 'T1574.010',
            zhcn: '劫持执行流程：服务文件权限弱点',
            id: 482
          },
          {
            attackid: 'T1574.011',
            zhcn: '劫持执行流程：服务注册表权限弱点',
            id: 483
          },
          {
            attackid: 'T1574.012',
            zhcn: '劫持执行流程：COR_PROFILER',
            id: 484
          },
          {
            attackid: 'T1574.013',
            zhcn: '劫持执行流程：内核回调表',
            id: 485
          },
          {
            attackid: 'T1574.014',
            zhcn: '劫持执行流程：应用程序域管理器',
            id: 486
          }
        ]
      },
      {
        attackid: 'T1497',
        zhcn: '虚拟化/沙箱逃逸',
        id: 150,
        children: [
          {
            attackid: 'T1497.001',
            zhcn: '虚拟化/沙箱逃逸：系统检查',
            id: 631
          },
          {
            attackid: 'T1497.002',
            zhcn: '虚拟化/沙箱逃逸：基于用户活动的检查',
            id: 632
          },
          {
            attackid: 'T1497.003',
            zhcn: '虚拟化/沙箱逃逸：基于时间的规避',
            id: 633
          }
        ]
      },
      {
        attackid: 'T1535',
        zhcn: '未使用/不支持的云区域',
        id: 149,
        children: []
      },
      {
        attackid: 'T1014',
        zhcn: 'Rootkit',
        id: 146,
        children: []
      },
      {
        attackid: 'T1027',
        zhcn: '混淆文件或信息',
        id: 142,
        children: [
          {
            attackid: 'T1027.001',
            zhcn: '混淆文件或信息：二进制填充',
            id: 591
          },
          {
            attackid: 'T1027.002',
            zhcn: '混淆文件或信息：软件打包',
            id: 592
          },
          {
            attackid: 'T1027.003',
            zhcn: '混淆文件或信息：隐写术',
            id: 593
          },
          {
            attackid: 'T1027.004',
            zhcn: '混淆文件或信息：交付后编译',
            id: 594
          },
          {
            attackid: 'T1027.005',
            zhcn: '混淆文件或信息：从工具中删除指标',
            id: 595
          },
          {
            attackid: 'T1027.006',
            zhcn: '混淆文件或信息：HTML 走私',
            id: 596
          },
          {
            attackid: 'T1027.007',
            zhcn: '混淆文件或信息：动态 API 解析',
            id: 597
          },
          {
            attackid: 'T1027.008',
            zhcn: '混淆文件或信息：精简的有效载荷',
            id: 598
          },
          {
            attackid: 'T1027.009',
            zhcn: '混淆文件或信息：嵌入式有效载荷',
            id: 599
          },
          {
            attackid: 'T1027.010',
            zhcn: '混淆文件或信息：命令混淆',
            id: 600
          },
          {
            attackid: 'T1027.011',
            zhcn: '混淆文件或信息：无文件存储',
            id: 601
          },
          {
            attackid: 'T1027.012',
            zhcn: '混淆文件或信息：LNK 图标走私',
            id: 602
          },
          {
            attackid: 'T1027.013',
            zhcn: '混淆文件或信息：加密/编码文件',
            id: 603
          },
          {
            attackid: 'T1027.014',
            zhcn: '混淆文件或信息：多态代码',
            id: 789
          }
        ]
      },
      {
        attackid: 'T1112',
        zhcn: '注册表修改',
        id: 139,
        children: []
      },
      {
        attackid: 'T1036',
        zhcn: '伪装',
        id: 138,
        children: [
          {
            attackid: 'T1036.001',
            zhcn: '伪装：无效的代码签名',
            id: 574
          },
          {
            attackid: 'T1036.002',
            zhcn: '伪装：从右到左覆盖',
            id: 575
          },
          {
            attackid: 'T1036.003',
            zhcn: '伪装：重命名系统实用程序',
            id: 576
          },
          {
            attackid: 'T1036.004',
            zhcn: '伪装：伪装任务或服务',
            id: 577
          },
          {
            attackid: 'T1036.005',
            zhcn: '伪装：匹配合法名称或位置',
            id: 578
          },
          {
            attackid: 'T1036.006',
            zhcn: '伪装：文件名后的空格',
            id: 579
          },
          {
            attackid: 'T1036.007',
            zhcn: '伪装：双文件扩展名',
            id: 580
          },
          {
            attackid: 'T1036.008',
            zhcn: '伪装：伪装文件类型',
            id: 581
          },
          {
            attackid: 'T1036.009',
            zhcn: '伪装：破坏进程树',
            id: 582
          },
          {
            attackid: 'T1036.010',
            zhcn: '伪装：伪装账户名',
            id: 787
          }
        ]
      },
      {
        attackid: 'T1202',
        zhcn: '间接命令执行',
        id: 135,
        children: []
      },
      {
        attackid: 'T1070',
        zhcn: '指标删除',
        id: 134,
        children: [
          {
            attackid: 'T1070.001',
            zhcn: '指标删除：清除 Windows 事件日志',
            id: 565
          },
          {
            attackid: 'T1070.002',
            zhcn: '指标删除：清除 Linux 或 Mac 系统日志',
            id: 566
          },
          {
            attackid: 'T1070.003',
            zhcn: '指标删除：清除命令历史',
            id: 567
          },
          {
            attackid: 'T1070.004',
            zhcn: '指标删除：文件删除',
            id: 568
          },
          {
            attackid: 'T1070.005',
            zhcn: '指标删除：网络共享连接删除',
            id: 569
          },
          {
            attackid: 'T1070.006',
            zhcn: '指标删除：时间篡改',
            id: 570
          },
          {
            attackid: 'T1070.007',
            zhcn: '指标删除：清除网络连接历史记录和配置',
            id: 571
          },
          {
            attackid: 'T1070.008',
            zhcn: '指标删除：清除邮箱数据',
            id: 572
          },
          {
            attackid: 'T1070.009',
            zhcn: '指标删除：清除持久性',
            id: 573
          },
          {
            attackid: 'T1070.010',
            zhcn: '指标删除：重新安置恶意软件',
            id: 786
          }
        ]
      },
      {
        attackid: 'T1484',
        zhcn: '域或租户策略修改',
        id: 128,
        children: [
          {
            attackid: 'T1484.001',
            zhcn: '域或租户策略修改：组策略修改',
            id: 525
          },
          {
            attackid: 'T1484.002',
            zhcn: '域或租户策略修改：信任修改',
            id: 526
          }
        ]
      },
      {
        attackid: 'T1006',
        zhcn: '直接卷访问',
        id: 126,
        children: []
      },
      {
        attackid: 'T1222',
        zhcn: '文件和目录权限修改',
        id: 125,
        children: [
          {
            attackid: 'T1222.001',
            zhcn: '文件和目录权限修改：Windows 文件和目录权限',
            id: 540
          },
          {
            attackid: 'T1222.002',
            zhcn: '文件和目录权限修改：Linux 和 Mac 文件和目录权限',
            id: 541
          }
        ]
      },
      {
        attackid: 'T1211',
        zhcn: '利用漏洞进行防御逃避',
        id: 123,
        children: []
      },
      {
        attackid: 'T1480',
        zhcn: '执行护栏',
        id: 122,
        children: [
          {
            attackid: 'T1480.001',
            zhcn: '执行护栏：环境密钥',
            id: 539
          },
          {
            attackid: 'T1480.002',
            zhcn: '执行护栏：互斥',
            id: 785
          }
        ]
      },
      {
        attackid: 'T1140',
        zhcn: '文件或信息解混淆/解码',
        id: 119,
        children: []
      },
      {
        attackid: 'T1207',
        zhcn: '恶意域控制器',
        id: 118,
        children: []
      },
      {
        attackid: 'T1221',
        zhcn: '模板注入',
        id: 112,
        children: []
      },
      {
        attackid: 'T1055',
        zhcn: '进程注入',
        id: 108,
        children: [
          {
            attackid: 'T1055.001',
            zhcn: '进程注入：动态链接库注入',
            id: 527
          },
          {
            attackid: 'T1055.002',
            zhcn: '进程注入：可移植可执行文件注入',
            id: 528
          },
          {
            attackid: 'T1055.003',
            zhcn: '进程注入：线程执行劫持',
            id: 529
          },
          {
            attackid: 'T1055.004',
            zhcn: '进程注入：异步过程调用',
            id: 530
          },
          {
            attackid: 'T1055.005',
            zhcn: '进程注入：线程本地存储',
            id: 531
          },
          {
            attackid: 'T1055.008',
            zhcn: '进程注入：Ptrace 系统调用',
            id: 532
          },
          {
            attackid: 'T1055.009',
            zhcn: '进程注入：进程内存',
            id: 533
          },
          {
            attackid: 'T1055.011',
            zhcn: '进程注入：额外窗口内存注入',
            id: 534
          },
          {
            attackid: 'T1055.012',
            zhcn: '进程注入：进程掏空',
            id: 535
          },
          {
            attackid: 'T1055.013',
            zhcn: '进程注入：进程替身',
            id: 536
          },
          {
            attackid: 'T1055.014',
            zhcn: '进程注入：VDSO 劫持',
            id: 537
          },
          {
            attackid: 'T1055.015',
            zhcn: '进程注入：列表植入',
            id: 538
          }
        ]
      },
      {
        attackid: 'T1134',
        zhcn: '访问令牌操纵',
        id: 102,
        children: [
          {
            attackid: 'T1134.001',
            zhcn: '访问令牌操纵：令牌模拟/窃取',
            id: 520
          },
          {
            attackid: 'T1134.002',
            zhcn: '访问令牌操纵：用令牌创建进程',
            id: 521
          },
          {
            attackid: 'T1134.003',
            zhcn: '访问令牌操纵：创建和模拟令牌',
            id: 522
          },
          {
            attackid: 'T1134.004',
            zhcn: '访问令牌操纵：父进程 ID 欺骗',
            id: 523
          },
          {
            attackid: 'T1134.005',
            zhcn: '访问令牌操纵：SID-History 注入',
            id: 524
          }
        ]
      },
      {
        attackid: 'T1205',
        zhcn: '流量信号',
        id: 82,
        children: [
          {
            attackid: 'T1205.001',
            zhcn: '流量信号：端口敲门',
            id: 512
          },
          {
            attackid: 'T1205.002',
            zhcn: '流量信号：套接字过滤器',
            id: 513
          }
        ]
      },
      {
        attackid: 'T1197',
        zhcn: 'BITS 作业',
        id: 54,
        children: []
      },
      {
        attackid: 'T1220',
        zhcn: 'XSL 脚本处理',
        id: 44,
        children: []
      },
      {
        attackid: 'T1127',
        zhcn: '受信任的开发人员实用程序代理执行',
        id: 40,
        children: [
          {
            attackid: 'T1127.001',
            zhcn: '受信任的开发人员实用程序代理执行：MSBuild',
            id: 626
          },
          {
            attackid: 'T1127.002',
            zhcn: '受信任的开发人员实用程序代理执行：ClickOnce',
            id: 795
          }
        ]
      },
      {
        attackid: 'T1216',
        zhcn: '签名脚本代理执行',
        id: 35,
        children: [
          {
            attackid: 'T1216.001',
            zhcn: '系统脚本代理执行：PubPrn',
            id: 624
          },
          {
            attackid: 'T1216.002',
            zhcn: '系统脚本代理执行：SyncAppvPublishingServer',
            id: 625
          }
        ]
      },
      {
        attackid: 'T1218',
        zhcn: '系统二进制代理执行',
        id: 34,
        children: [
          {
            attackid: 'T1218.001',
            zhcn: '系统二进制代理执行：编译的 HTML 文件',
            id: 610
          },
          {
            attackid: 'T1218.002',
            zhcn: '系统二进制代理执行：控制面板',
            id: 611
          },
          {
            attackid: 'T1218.003',
            zhcn: '系统二进制代理执行：CMSTP',
            id: 612
          },
          {
            attackid: 'T1218.004',
            zhcn: '系统二进制代理执行：InstallUtil',
            id: 613
          },
          {
            attackid: 'T1218.005',
            zhcn: '系统二进制代理执行：Mshta',
            id: 614
          },
          {
            attackid: 'T1218.007',
            zhcn: '系统二进制代理执行：Msiexec',
            id: 615
          },
          {
            attackid: 'T1218.008',
            zhcn: '系统二进制代理执行：Odbcconf',
            id: 616
          },
          {
            attackid: 'T1218.009',
            zhcn: '系统二进制代理执行：Regsvcs/Regasm',
            id: 617
          },
          {
            attackid: 'T1218.010',
            zhcn: '系统二进制代理执行：Regsvr32',
            id: 618
          },
          {
            attackid: 'T1218.011',
            zhcn: '系统二进制代理执行：Rundll32',
            id: 619
          },
          {
            attackid: 'T1218.012',
            zhcn: '系统二进制代理执行：Verclsid',
            id: 620
          },
          {
            attackid: 'T1218.013',
            zhcn: '系统二进制代理执行：Mavinject',
            id: 621
          },
          {
            attackid: 'T1218.014',
            zhcn: '系统二进制代理执行：MMC',
            id: 622
          },
          {
            attackid: 'T1218.015',
            zhcn: '系统二进制代理执行：Electron 应用程序',
            id: 623
          }
        ]
      },
      {
        attackid: 'T1078',
        zhcn: '有效账户',
        id: 11,
        children: [
          {
            attackid: 'T1078.001',
            zhcn: '有效账户：默认账户',
            id: 398
          },
          {
            attackid: 'T1078.002',
            zhcn: '有效账户：域账户',
            id: 399
          },
          {
            attackid: 'T1078.003',
            zhcn: '有效账户：本地账户',
            id: 400
          },
          {
            attackid: 'T1078.004',
            zhcn: '有效账户：云账户',
            id: 401
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0006',
    zhcn: '凭据访问',
    attack_list: [
      {
        attackid: 'T1552',
        zhcn: '不安全的凭据',
        id: 642,
        children: [
          {
            attackid: 'T1552.001',
            zhcn: '不安全的凭据：文件中的凭据',
            id: 674
          },
          {
            attackid: 'T1552.002',
            zhcn: '不安全的凭据：注册表中的凭据',
            id: 675
          },
          {
            attackid: 'T1552.003',
            zhcn: '不安全的凭据：Bash 历史记录',
            id: 676
          },
          {
            attackid: 'T1552.004',
            zhcn: '不安全的凭据：私钥',
            id: 677
          },
          {
            attackid: 'T1552.005',
            zhcn: '不安全的凭据：云实例元数据 API',
            id: 678
          },
          {
            attackid: 'T1552.006',
            zhcn: '不安全的凭据：组策略首选项',
            id: 679
          },
          {
            attackid: 'T1552.007',
            zhcn: '不安全的凭据：容器 API',
            id: 680
          },
          {
            attackid: 'T1552.008',
            zhcn: '不安全的凭据：聊天消息',
            id: 681
          }
        ]
      },
      {
        attackid: 'T1558',
        zhcn: '窃取或伪造 Kerberos 票证',
        id: 641,
        children: [
          {
            attackid: 'T1558.001',
            zhcn: '窃取或伪造 Kerberos 票证：黄金票证',
            id: 670
          },
          {
            attackid: 'T1558.002',
            zhcn: '窃取或伪造 Kerberos 票证：白银票证',
            id: 671
          },
          {
            attackid: 'T1558.003',
            zhcn: '窃取或伪造 Kerberos 票证：Kerberoasting',
            id: 672
          },
          {
            attackid: 'T1558.004',
            zhcn: '窃取或伪造 Kerberos 票证：AS-REP 烘烤',
            id: 673
          },
          {
            attackid: 'T1558.005',
            zhcn: '窃取或伪造 Kerberos 票证：Ccache 文件',
            id: 794
          }
        ]
      },
      {
        attackid: 'T1649',
        zhcn: '窃取或伪造身份验证证书',
        id: 640,
        children: []
      },
      {
        attackid: 'T1621',
        zhcn: '多因素身份验证请求生成',
        id: 639,
        children: []
      },
      {
        attackid: 'T1606',
        zhcn: '伪造网络凭据',
        id: 638,
        children: [
          {
            attackid: 'T1606.001',
            zhcn: '伪造网络凭据：网络 Cookie',
            id: 656
          },
          {
            attackid: 'T1606.002',
            zhcn: '伪造网络凭据：SAML 令牌',
            id: 657
          }
        ]
      },
      {
        attackid: 'T1555',
        zhcn: '来自密码存储的凭据',
        id: 637,
        children: [
          {
            attackid: 'T1555.001',
            zhcn: '来自密码存储的凭据：钥匙串',
            id: 650
          },
          {
            attackid: 'T1555.002',
            zhcn: '来自密码存储的凭据：Securityd 内存',
            id: 651
          },
          {
            attackid: 'T1555.003',
            zhcn: '来自密码存储的凭据：来自网络浏览器的凭据',
            id: 652
          },
          {
            attackid: 'T1555.004',
            zhcn: '来自密码存储的凭据：Windows 凭据管理器',
            id: 653
          },
          {
            attackid: 'T1555.005',
            zhcn: '来自密码存储的凭据：密码管理器',
            id: 654
          },
          {
            attackid: 'T1555.006',
            zhcn: '来自密码存储的凭据：云机密管理存储',
            id: 655
          }
        ]
      },
      {
        attackid: 'T1557',
        zhcn: '中间人攻击者',
        id: 636,
        children: [
          {
            attackid: 'T1557.001',
            zhcn: '中间人攻击者：LLMNR/NBT-NS 中毒和 SMB 中继',
            id: 643
          },
          {
            attackid: 'T1557.002',
            zhcn: '中间人攻击者：ARP 缓存中毒',
            id: 644
          },
          {
            attackid: 'T1557.003',
            zhcn: '中间人攻击者：DHCP 欺骗',
            id: 645
          },
          {
            attackid: 'T1557.004',
            zhcn: '中间人攻击者：邪恶双胞胎',
            id: 778
          }
        ]
      },
      {
        attackid: 'T1556',
        zhcn: '修改认证过程',
        id: 300,
        children: [
          {
            attackid: 'T1556.001',
            zhcn: '修改认证过程：域控制器认证',
            id: 487
          },
          {
            attackid: 'T1556.002',
            zhcn: '修改认证过程：密码筛选 DLL',
            id: 488
          },
          {
            attackid: 'T1556.003',
            zhcn: '修改认证过程：可插拔认证模块',
            id: 489
          },
          {
            attackid: 'T1556.004',
            zhcn: '修改认证过程：网络设备认证',
            id: 490
          },
          {
            attackid: 'T1556.005',
            zhcn: '修改认证过程：可逆加密',
            id: 491
          },
          {
            attackid: 'T1556.006',
            zhcn: '修改认证过程：多因素认证',
            id: 492
          },
          {
            attackid: 'T1556.007',
            zhcn: '修改认证过程：混合身份',
            id: 493
          },
          {
            attackid: 'T1556.008',
            zhcn: '修改认证过程：网络提供程序 DLL',
            id: 494
          },
          {
            attackid: 'T1556.009',
            zhcn: '修改认证过程：条件访问策略',
            id: 495
          }
        ]
      },
      {
        attackid: 'T1111',
        zhcn: '多因素身份验证拦截',
        id: 174,
        children: []
      },
      {
        attackid: 'T1539',
        zhcn: '窃取 Web 会话 Cookie',
        id: 173,
        children: []
      },
      {
        attackid: 'T1528',
        zhcn: '窃取应用程序访问令牌',
        id: 172,
        children: []
      },
      {
        attackid: 'T1040',
        zhcn: '网络嗅探',
        id: 168,
        children: []
      },
      {
        attackid: 'T1056',
        zhcn: '输入捕获',
        id: 163,
        children: [
          {
            attackid: 'T1056.001',
            zhcn: '输入捕获：键盘记录',
            id: 658
          },
          {
            attackid: 'T1056.002',
            zhcn: '输入捕获：图形用户界面输入捕获',
            id: 659
          },
          {
            attackid: 'T1056.003',
            zhcn: '输入捕获：网络门户捕获',
            id: 660
          },
          {
            attackid: 'T1056.004',
            zhcn: '输入捕获：凭证 API 挂钩',
            id: 661
          }
        ]
      },
      {
        attackid: 'T1187',
        zhcn: '强制认证',
        id: 162,
        children: []
      },
      {
        attackid: 'T1212',
        zhcn: '凭据访问利用',
        id: 161,
        children: []
      },
      {
        attackid: 'T1003',
        zhcn: '操作系统凭证转储',
        id: 157,
        children: [
          {
            attackid: 'T1003.001',
            zhcn: '操作系统凭证转储：LSASS 内存',
            id: 662
          },
          {
            attackid: 'T1003.002',
            zhcn: '操作系统凭证转储：安全帐户管理器',
            id: 663
          },
          {
            attackid: 'T1003.003',
            zhcn: '操作系统凭证转储：NTDS',
            id: 664
          },
          {
            attackid: 'T1003.004',
            zhcn: '操作系统凭证转储：LSA 机密',
            id: 665
          },
          {
            attackid: 'T1003.005',
            zhcn: '操作系统凭证转储：缓存的域凭证',
            id: 666
          },
          {
            attackid: 'T1003.006',
            zhcn: '操作系统凭证转储：DCSync',
            id: 667
          },
          {
            attackid: 'T1003.007',
            zhcn: '操作系统凭证转储：进程文件系统',
            id: 668
          },
          {
            attackid: 'T1003.008',
            zhcn: '操作系统凭证转储：/etc/passwd 和 /etc/shadow',
            id: 669
          }
        ]
      },
      {
        attackid: 'T1110',
        zhcn: '暴力破解',
        id: 154,
        children: [
          {
            attackid: 'T1110.001',
            zhcn: '暴力破解：密码猜测',
            id: 646
          },
          {
            attackid: 'T1110.002',
            zhcn: '暴力破解：密码破解',
            id: 647
          },
          {
            attackid: 'T1110.003',
            zhcn: '暴力破解：密码喷射',
            id: 648
          },
          {
            attackid: 'T1110.004',
            zhcn: '暴力破解：凭据填充',
            id: 649
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0007',
    zhcn: '发现',
    attack_list: [
      {
        attackid: 'T1654',
        zhcn: '日志枚举',
        id: 687,
        children: []
      },
      {
        attackid: 'T1615',
        zhcn: '组策略发现',
        id: 686,
        children: []
      },
      {
        attackid: 'T1652',
        zhcn: '设备驱动程序发现',
        id: 685,
        children: []
      },
      {
        attackid: 'T1613',
        zhcn: '容器和资源发现',
        id: 684,
        children: []
      },
      {
        attackid: 'T1619',
        zhcn: '云存储对象发现',
        id: 683,
        children: []
      },
      {
        attackid: 'T1580',
        zhcn: '云基础设施发现',
        id: 682,
        children: []
      },
      {
        attackid: 'T1622',
        zhcn: '调试器逃避',
        id: 306,
        children: []
      },
      {
        attackid: 'T1614',
        zhcn: '系统位置发现',
        id: 269,
        children: [
          {
            attackid: 'T1614.001',
            zhcn: '系统位置发现：系统语言发现',
            id: 696
          }
        ]
      },
      {
        attackid: 'T1124',
        zhcn: '系统时间发现',
        id: 197,
        children: []
      },
      {
        attackid: 'T1007',
        zhcn: '系统服务发现',
        id: 196,
        children: []
      },
      {
        attackid: 'T1033',
        zhcn: '系统所有者/用户发现',
        id: 195,
        children: []
      },
      {
        attackid: 'T1049',
        zhcn: '系统网络连接发现',
        id: 194,
        children: []
      },
      {
        attackid: 'T1016',
        zhcn: '系统网络配置发现',
        id: 193,
        children: [
          {
            attackid: 'T1016.001',
            zhcn: '系统网络配置发现：互联网连接发现',
            id: 697
          },
          {
            attackid: 'T1016.002',
            zhcn: '系统网络配置发现：Wi-Fi 发现',
            id: 698
          }
        ]
      },
      {
        attackid: 'T1082',
        zhcn: '系统信息发现',
        id: 192,
        children: []
      },
      {
        attackid: 'T1518',
        zhcn: '软件发现',
        id: 191,
        children: [
          {
            attackid: 'T1518.001',
            zhcn: '软件发现：安全软件发现',
            id: 695
          }
        ]
      },
      {
        attackid: 'T1018',
        zhcn: '远程系统发现',
        id: 189,
        children: []
      },
      {
        attackid: 'T1012',
        zhcn: '查询注册表',
        id: 188,
        children: []
      },
      {
        attackid: 'T1057',
        zhcn: '进程发现',
        id: 187,
        children: []
      },
      {
        attackid: 'T1069',
        zhcn: '权限组发现',
        id: 186,
        children: [
          {
            attackid: 'T1069.001',
            zhcn: '权限组发现：本地组',
            id: 692
          },
          {
            attackid: 'T1069.002',
            zhcn: '权限组发现：域组',
            id: 693
          },
          {
            attackid: 'T1069.003',
            zhcn: '权限组发现：云组',
            id: 694
          }
        ]
      },
      {
        attackid: 'T1120',
        zhcn: '周边设备发现',
        id: 185,
        children: []
      },
      {
        attackid: 'T1201',
        zhcn: '密码策略发现',
        id: 184,
        children: []
      },
      {
        attackid: 'T1135',
        zhcn: '网络共享发现',
        id: 183,
        children: []
      },
      {
        attackid: 'T1046',
        zhcn: '网络服务发现',
        id: 182,
        children: []
      },
      {
        attackid: 'T1083',
        zhcn: '文件和目录发现',
        id: 181,
        children: []
      },
      {
        attackid: 'T1482',
        zhcn: '域信任发现',
        id: 180,
        children: []
      },
      {
        attackid: 'T1526',
        zhcn: '云服务发现',
        id: 179,
        children: []
      },
      {
        attackid: 'T1538',
        zhcn: '云服务仪表盘',
        id: 178,
        children: []
      },
      {
        attackid: 'T1217',
        zhcn: '浏览器信息发现',
        id: 177,
        children: []
      },
      {
        attackid: 'T1010',
        zhcn: '应用窗口发现',
        id: 176,
        children: []
      },
      {
        attackid: 'T1087',
        zhcn: '账户发现',
        id: 175,
        children: [
          {
            attackid: 'T1087.001',
            zhcn: '账户发现：本地账户',
            id: 688
          },
          {
            attackid: 'T1087.002',
            zhcn: '账户发现：域账户',
            id: 689
          },
          {
            attackid: 'T1087.003',
            zhcn: '账户发现：电子邮件账户',
            id: 690
          },
          {
            attackid: 'T1087.004',
            zhcn: '账户发现：云账户',
            id: 691
          }
        ]
      },
      {
        attackid: 'T1040',
        zhcn: '网络嗅探',
        id: 168,
        children: []
      },
      {
        attackid: 'T1497',
        zhcn: '虚拟化/沙箱逃逸',
        id: 150,
        children: [
          {
            attackid: 'T1497.001',
            zhcn: '虚拟化/沙箱逃逸：系统检查',
            id: 631
          },
          {
            attackid: 'T1497.002',
            zhcn: '虚拟化/沙箱逃逸：基于用户活动的检查',
            id: 632
          },
          {
            attackid: 'T1497.003',
            zhcn: '虚拟化/沙箱逃逸：基于时间的规避',
            id: 633
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0008',
    zhcn: '横向移动',
    attack_list: [
      {
        attackid: 'T1563',
        zhcn: '远程服务会话劫持',
        id: 700,
        children: [
          {
            attackid: 'T1563.001',
            zhcn: '远程服务会话劫持：SSH 劫持',
            id: 701
          },
          {
            attackid: 'T1563.002',
            zhcn: '远程服务会话劫持：RDP 劫持',
            id: 702
          }
        ]
      },
      {
        attackid: 'T1570',
        zhcn: '横向工具转移',
        id: 699,
        children: []
      },
      {
        attackid: 'T1550',
        zhcn: '使用替代身份验证材料',
        id: 316,
        children: [
          {
            attackid: 'T1550.001',
            zhcn: '使用替代身份验证材料：应用程序访问令牌',
            id: 627
          },
          {
            attackid: 'T1550.002',
            zhcn: '使用替代身份验证材料：传递哈希',
            id: 628
          },
          {
            attackid: 'T1550.003',
            zhcn: '使用替代身份验证材料：传递票据',
            id: 629
          },
          {
            attackid: 'T1550.004',
            zhcn: '使用替代身份验证材料：Web 会话 Cookie',
            id: 630
          }
        ]
      },
      {
        attackid: 'T1080',
        zhcn: '共享内容污点',
        id: 208,
        children: []
      },
      {
        attackid: 'T1021',
        zhcn: '远程服务',
        id: 205,
        children: [
          {
            attackid: 'T1021.001',
            zhcn: '远程服务：远程桌面协议',
            id: 703
          },
          {
            attackid: 'T1021.002',
            zhcn: '远程服务：SMB/Windows 管理共享',
            id: 704
          },
          {
            attackid: 'T1021.003',
            zhcn: '远程服务：分布式组件对象模型',
            id: 705
          },
          {
            attackid: 'T1021.004',
            zhcn: '远程服务：SSH',
            id: 706
          },
          {
            attackid: 'T1021.005',
            zhcn: '远程服务：VNC',
            id: 707
          },
          {
            attackid: 'T1021.006',
            zhcn: '远程服务：Windows 远程管理',
            id: 708
          },
          {
            attackid: 'T1021.007',
            zhcn: '远程服务：云服务',
            id: 709
          },
          {
            attackid: 'T1021.008',
            zhcn: '远程服务：直接云虚拟机连接',
            id: 710
          }
        ]
      },
      {
        attackid: 'T1534',
        zhcn: '内部鱼叉式钓鱼攻击',
        id: 202,
        children: []
      },
      {
        attackid: 'T1210',
        zhcn: '远程服务利用',
        id: 199,
        children: []
      },
      {
        attackid: 'T1072',
        zhcn: '软件部署工具',
        id: 38,
        children: []
      },
      {
        attackid: 'T1091',
        zhcn: '通过移动存储进行复制',
        id: 5,
        children: []
      }
    ]
  },
  {
    tacticid: 'TA0009',
    zhcn: '采集',
    attack_list: [
      {
        attackid: 'T1602',
        zhcn: '配置存储库中的数据',
        id: 715,
        children: [
          {
            attackid: 'T1602.001',
            zhcn: '配置存储库中的数据：SNMP（管理信息库转储）',
            id: 716
          },
          {
            attackid: 'T1602.002',
            zhcn: '配置存储库中的数据：网络设备配置转储',
            id: 717
          }
        ]
      },
      {
        attackid: 'T1560',
        zhcn: '归档收集的数据',
        id: 711,
        children: [
          {
            attackid: 'T1560.001',
            zhcn: '归档收集的数据：通过实用程序归档',
            id: 712
          },
          {
            attackid: 'T1560.002',
            zhcn: '归档收集的数据：通过库归档',
            id: 713
          },
          {
            attackid: 'T1560.003',
            zhcn: '归档收集的数据：通过自定义方法归档',
            id: 714
          }
        ]
      },
      {
        attackid: 'T1557',
        zhcn: '中间人攻击者',
        id: 636,
        children: [
          {
            attackid: 'T1557.001',
            zhcn: '中间人攻击者：LLMNR/NBT-NS 中毒和 SMB 中继',
            id: 643
          },
          {
            attackid: 'T1557.002',
            zhcn: '中间人攻击者：ARP 缓存中毒',
            id: 644
          },
          {
            attackid: 'T1557.003',
            zhcn: '中间人攻击者：DHCP 欺骗',
            id: 645
          },
          {
            attackid: 'T1557.004',
            zhcn: '中间人攻击者：邪恶双胞胎',
            id: 778
          }
        ]
      },
      {
        attackid: 'T1125',
        zhcn: '视频捕获',
        id: 222,
        children: []
      },
      {
        attackid: 'T1113',
        zhcn: '屏幕截图',
        id: 221,
        children: []
      },
      {
        attackid: 'T1185',
        zhcn: '浏览器会话劫持',
        id: 220,
        children: []
      },
      {
        attackid: 'T1114',
        zhcn: '电子邮件收集',
        id: 219,
        children: [
          {
            attackid: 'T1114.001',
            zhcn: '电子邮件收集：本地电子邮件收集',
            id: 723
          },
          {
            attackid: 'T1114.002',
            zhcn: '电子邮件收集：远程电子邮件收集',
            id: 724
          },
          {
            attackid: 'T1114.003',
            zhcn: '电子邮件收集：电子邮件转发规则',
            id: 725
          }
        ]
      },
      {
        attackid: 'T1074',
        zhcn: '数据暂存',
        id: 218,
        children: [
          {
            attackid: 'T1074.001',
            zhcn: '数据暂存：本地数据暂存',
            id: 721
          },
          {
            attackid: 'T1074.002',
            zhcn: '数据暂存：远程数据暂存',
            id: 722
          }
        ]
      },
      {
        attackid: 'T1025',
        zhcn: '可移动媒体中的数据',
        id: 217,
        children: []
      },
      {
        attackid: 'T1039',
        zhcn: '共享网络驱动器中的数据',
        id: 216,
        children: []
      },
      {
        attackid: 'T1005',
        zhcn: '本地系统中的数据',
        id: 215,
        children: []
      },
      {
        attackid: 'T1213',
        zhcn: '信息存储库中的数据',
        id: 214,
        children: [
          {
            attackid: 'T1213.001',
            zhcn: '信息存储库中的数据：Confluence',
            id: 718
          },
          {
            attackid: 'T1213.002',
            zhcn: '信息存储库中的数据：SharePoint',
            id: 719
          },
          {
            attackid: 'T1213.003',
            zhcn: '信息存储库中的数据：代码存储库',
            id: 720
          },
          {
            attackid: 'T1213.004',
            zhcn: '信息存储库中的数据：客户关系管理软件',
            id: 782
          },
          {
            attackid: 'T1213.005',
            zhcn: '信息存储库中的数据：消息应用程序',
            id: 783
          }
        ]
      },
      {
        attackid: 'T1530',
        zhcn: '云存储中的数据',
        id: 213,
        children: []
      },
      {
        attackid: 'T1115',
        zhcn: '剪贴板数据',
        id: 212,
        children: []
      },
      {
        attackid: 'T1119',
        zhcn: '自动化收集',
        id: 211,
        children: []
      },
      {
        attackid: 'T1123',
        zhcn: '音频捕获',
        id: 210,
        children: []
      },
      {
        attackid: 'T1056',
        zhcn: '输入捕获',
        id: 163,
        children: [
          {
            attackid: 'T1056.001',
            zhcn: '输入捕获：键盘记录',
            id: 658
          },
          {
            attackid: 'T1056.002',
            zhcn: '输入捕获：图形用户界面输入捕获',
            id: 659
          },
          {
            attackid: 'T1056.003',
            zhcn: '输入捕获：网络门户捕获',
            id: 660
          },
          {
            attackid: 'T1056.004',
            zhcn: '输入捕获：凭证 API 挂钩',
            id: 661
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0011',
    zhcn: '命令与控制',
    attack_list: [
      {
        attackid: 'T1571',
        zhcn: '非标准端口',
        id: 742,
        children: []
      },
      {
        attackid: 'T1665',
        zhcn: '隐藏基础设施',
        id: 741,
        children: []
      },
      {
        attackid: 'T1573',
        zhcn: '加密通道',
        id: 739,
        children: [
          {
            attackid: 'T1573.001',
            zhcn: '加密通道：对称加密',
            id: 740
          }
        ]
      },
      {
        attackid: 'T1568',
        zhcn: '动态解析',
        id: 735,
        children: [
          {
            attackid: 'T1568.001',
            zhcn: '动态解析：快速流量 DNS',
            id: 736
          },
          {
            attackid: 'T1568.002',
            zhcn: '动态解析：域名生成算法（DGA）',
            id: 737
          },
          {
            attackid: 'T1568.003',
            zhcn: '动态解析：DNS 计算',
            id: 738
          }
        ]
      },
      {
        attackid: 'T1659',
        zhcn: '内容注入',
        id: 289,
        children: []
      },
      {
        attackid: 'T1572',
        zhcn: '协议隧道',
        id: 270,
        children: []
      },
      {
        attackid: 'T1095',
        zhcn: '非应用层协议',
        id: 249,
        children: []
      },
      {
        attackid: 'T1071',
        zhcn: '应用层协议',
        id: 247,
        children: [
          {
            attackid: 'T1071.001',
            zhcn: '应用层协议：网络协议',
            id: 726
          },
          {
            attackid: 'T1071.002',
            zhcn: '应用层协议：文件传输协议',
            id: 727
          },
          {
            attackid: 'T1071.003',
            zhcn: '应用层协议：邮件协议',
            id: 728
          },
          {
            attackid: 'T1071.004',
            zhcn: '应用层协议：DNS',
            id: 729
          },
          {
            attackid: 'T1071.005',
            zhcn: '应用层协议：发布/订阅协议',
            id: 779
          }
        ]
      },
      {
        attackid: 'T1219',
        zhcn: '远程访问软件',
        id: 246,
        children: []
      },
      {
        attackid: 'T1104',
        zhcn: '多阶段信道',
        id: 243,
        children: []
      },
      {
        attackid: 'T1008',
        zhcn: '失败回退通道',
        id: 241,
        children: []
      },
      {
        attackid: 'T1001',
        zhcn: '数据混淆',
        id: 238,
        children: [
          {
            attackid: 'T1001.001',
            zhcn: '数据混淆：垃圾数据',
            id: 732
          },
          {
            attackid: 'T1001.002',
            zhcn: '数据混淆：隐写术',
            id: 733
          },
          {
            attackid: 'T1001.003',
            zhcn: '数据混淆：协议模拟',
            id: 734
          }
        ]
      },
      {
        attackid: 'T1132',
        zhcn: '数据编码',
        id: 237,
        children: [
          {
            attackid: 'T1132.001',
            zhcn: '数据编码：标准编码',
            id: 730
          },
          {
            attackid: 'T1132.002',
            zhcn: '数据编码：非标准编码',
            id: 731
          }
        ]
      },
      {
        attackid: 'T1092',
        zhcn: '经由可移动媒体通信',
        id: 234,
        children: []
      },
      {
        attackid: 'T1105',
        zhcn: '入口工具传输',
        id: 204,
        children: []
      },
      {
        attackid: 'T1090',
        zhcn: '代理',
        id: 153,
        children: [
          {
            attackid: 'T1090.001',
            zhcn: '代理：内部代理',
            id: 743
          },
          {
            attackid: 'T1090.002',
            zhcn: '代理：外部代理',
            id: 744
          },
          {
            attackid: 'T1090.003',
            zhcn: '代理：多跳代理',
            id: 745
          },
          {
            attackid: 'T1090.004',
            zhcn: '代理：域名前置',
            id: 746
          }
        ]
      },
      {
        attackid: 'T1102',
        zhcn: 'Web 服务',
        id: 151,
        children: [
          {
            attackid: 'T1102.001',
            zhcn: 'Web 服务：死信投递解析器',
            id: 747
          },
          {
            attackid: 'T1102.002',
            zhcn: 'Web 服务：双向通信',
            id: 748
          },
          {
            attackid: 'T1102.003',
            zhcn: 'Web 服务：单向通信',
            id: 749
          }
        ]
      },
      {
        attackid: 'T1205',
        zhcn: '流量信号',
        id: 82,
        children: [
          {
            attackid: 'T1205.001',
            zhcn: '流量信号：端口敲门',
            id: 512
          },
          {
            attackid: 'T1205.002',
            zhcn: '流量信号：套接字过滤器',
            id: 513
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0010',
    zhcn: '数据渗漏',
    attack_list: [
      {
        attackid: 'T1567',
        zhcn: '通过网络服务数据渗漏',
        id: 756,
        children: [
          {
            attackid: 'T1567.001',
            zhcn: '通过网络服务数据渗漏：向代码存储库数据渗漏',
            id: 757
          },
          {
            attackid: 'T1567.002',
            zhcn: '通过网络服务数据渗漏：向云存储数据渗漏',
            id: 758
          },
          {
            attackid: 'T1567.003',
            zhcn: '通过网络服务数据渗漏：向文本存储网站数据渗漏',
            id: 759
          },
          {
            attackid: 'T1567.004',
            zhcn: '通过网络服务数据渗漏：通过 Webhook 数据渗漏',
            id: 760
          }
        ]
      },
      {
        attackid: 'T1537',
        zhcn: '将数据传输到云账户',
        id: 232,
        children: []
      },
      {
        attackid: 'T1029',
        zhcn: '定时传输',
        id: 231,
        children: []
      },
      {
        attackid: 'T1052',
        zhcn: '通过物理媒介数据渗漏',
        id: 230,
        children: [
          {
            attackid: 'T1052.001',
            zhcn: '通过物理媒介数据渗漏：通过 USB 数据渗漏',
            id: 755
          }
        ]
      },
      {
        attackid: 'T1011',
        zhcn: '通过其他网络媒介数据渗漏',
        id: 229,
        children: [
          {
            attackid: 'T1011.001',
            zhcn: '通过其他网络媒介数据渗漏：通过蓝牙数据渗漏',
            id: 754
          }
        ]
      },
      {
        attackid: 'T1041',
        zhcn: '通过 C2 通道数据渗漏',
        id: 228,
        children: []
      },
      {
        attackid: 'T1048',
        zhcn: '通过替代协议数据渗漏',
        id: 227,
        children: [
          {
            attackid: 'T1048.001',
            zhcn: '通过替代协议数据渗漏：通过对称加密非 C2 协议数据渗漏',
            id: 751
          },
          {
            attackid: 'T1048.002',
            zhcn: '通过替代协议数据渗漏：通过非对称加密非 C2 协议数据渗漏',
            id: 752
          },
          {
            attackid: 'T1048.003',
            zhcn: '通过替代协议数据渗漏：通过未加密非 C2 协议数据渗漏',
            id: 753
          }
        ]
      },
      {
        attackid: 'T1030',
        zhcn: '数据传输大小限制',
        id: 226,
        children: []
      },
      {
        attackid: 'T1020',
        zhcn: '自动化数据渗漏',
        id: 223,
        children: [
          {
            attackid: 'T1020.001',
            zhcn: '自动化数据渗漏：流量复制',
            id: 750
          }
        ]
      }
    ]
  },
  {
    tacticid: 'TA0040',
    zhcn: '恶劣影响',
    attack_list: [
      {
        attackid: 'T1657',
        zhcn: '金融盗窃',
        id: 774,
        children: []
      },
      {
        attackid: 'T1561',
        zhcn: '磁盘擦除',
        id: 767,
        children: [
          {
            attackid: 'T1561.001',
            zhcn: '磁盘擦除：磁盘内容擦除',
            id: 768
          },
          {
            attackid: 'T1561.002',
            zhcn: '磁盘擦除：磁盘结构擦除',
            id: 769
          }
        ]
      },
      {
        attackid: 'T1565',
        zhcn: '数据操纵',
        id: 761,
        children: [
          {
            attackid: 'T1565.001',
            zhcn: '数据操纵：存储数据操纵',
            id: 762
          },
          {
            attackid: 'T1565.002',
            zhcn: '数据操纵：传输数据操纵',
            id: 763
          },
          {
            attackid: 'T1565.003',
            zhcn: '数据操纵：运行时数据操纵',
            id: 764
          }
        ]
      },
      {
        attackid: 'T1529',
        zhcn: '系统关闭/重启',
        id: 265,
        children: []
      },
      {
        attackid: 'T1489',
        zhcn: '服务停止',
        id: 263,
        children: []
      },
      {
        attackid: 'T1496',
        zhcn: '资源劫持',
        id: 261,
        children: [
          {
            attackid: 'T1496.002',
            zhcn: '资源劫持：带宽劫持',
            id: 790
          },
          {
            attackid: 'T1496.004',
            zhcn: '资源劫持：云服务劫持',
            id: 791
          },
          {
            attackid: 'T1496.001',
            zhcn: '资源劫持：计算劫持',
            id: 792
          },
          {
            attackid: 'T1496.003',
            zhcn: '资源劫持：短信轰炸',
            id: 793
          }
        ]
      },
      {
        attackid: 'T1490',
        zhcn: '禁止系统恢复',
        id: 260,
        children: []
      },
      {
        attackid: 'T1495',
        zhcn: '固件损坏',
        id: 259,
        children: []
      },
      {
        attackid: 'T1499',
        zhcn: '端点拒绝服务',
        id: 258,
        children: [
          {
            attackid: 'T1499.001',
            zhcn: '端点拒绝服务：操作系统资源耗尽洪流',
            id: 770
          },
          {
            attackid: 'T1499.002',
            zhcn: '端点拒绝服务：服务资源耗尽洪流',
            id: 771
          },
          {
            attackid: 'T1499.003',
            zhcn: '端点拒绝服务：应用程序资源耗尽洪流',
            id: 772
          },
          {
            attackid: 'T1499.004',
            zhcn: '端点拒绝服务：应用程序或系统利用',
            id: 773
          }
        ]
      },
      {
        attackid: 'T1491',
        zhcn: '污损攻击',
        id: 255,
        children: [
          {
            attackid: 'T1491.001',
            zhcn: '污损攻击：内部污损攻击',
            id: 765
          },
          {
            attackid: 'T1491.002',
            zhcn: '污损攻击：外部污损攻击',
            id: 766
          }
        ]
      },
      {
        attackid: 'T1486',
        zhcn: '为了恶劣影响而数据加密',
        id: 254,
        children: []
      },
      {
        attackid: 'T1485',
        zhcn: '数据销毁',
        id: 253,
        children: [
          {
            attackid: 'T1485.001',
            zhcn: '数据销毁：生命周期触发的删除',
            id: 781
          }
        ]
      },
      {
        attackid: 'T1531',
        zhcn: '账户访问移除',
        id: 252,
        children: []
      },
      {
        attackid: 'T1498',
        zhcn: '网络拒绝服务',
        id: 251,
        children: [
          {
            attackid: 'T1498.001',
            zhcn: '网络拒绝服务：直接网络洪流',
            id: 775
          },
          {
            attackid: 'T1498.002',
            zhcn: '网络拒绝服务：反射放大',
            id: 776
          }
        ]
      }
    ]
  }
]
export default mitre
